export const GENERIC_EMAIL_PROVIDERS = {
  'biggerpicture.co': true,
  '0-mail.com': true,
  '007addict.com': true,
  '020.co.uk': true,
  '027168.com': true,
  '0815.ru': true,
  '0815.su': true,
  '0clickemail.com': true,
  '0sg.net': true,
  '0wnd.net': true,
  '0wnd.org': true,
  '1033edge.com': true,
  '10mail.org': true,
  '10minutemail.co.za': true,
  '10minutemail.com': true,
  '11mail.com': true,
  '123-m.com': true,
  '123.com': true,
  '123box.net': true,
  '123india.com': true,
  '123mail.cl': true,
  '123mail.org': true,
  '123qwe.co.uk': true,
  '126.com': true,
  '126.net': true,
  '138mail.com': true,
  '139.com': true,
  '150mail.com': true,
  '150ml.com': true,
  '15meg4free.com': true,
  '163.com': true,
  '16mail.com': true,
  '188.com': true,
  '189.cn': true,
  '1auto.com': true,
  '1ce.us': true,
  '1chuan.com': true,
  '1colony.com': true,
  '1coolplace.com': true,
  '1email.eu': true,
  '1freeemail.com': true,
  '1fsdfdsfsdf.tk': true,
  '1funplace.com': true,
  '1internetdrive.com': true,
  '1mail.ml': true,
  '1mail.net': true,
  '1me.net': true,
  '1mum.com': true,
  '1musicrow.com': true,
  '1netdrive.com': true,
  '1nsyncfan.com': true,
  '1pad.de': true,
  '1under.com': true,
  '1webave.com': true,
  '1webhighway.com': true,
  '1zhuan.com': true,
  '2-mail.com': true,
  '20email.eu': true,
  '20mail.in': true,
  '20mail.it': true,
  '20minutemail.com': true,
  '212.com': true,
  '21cn.com': true,
  '247emails.com': true,
  '24horas.com': true,
  '2911.net': true,
  '2980.com': true,
  '2bmail.co.uk': true,
  '2coolforyou.net': true,
  '2d2i.com': true,
  '2die4.com': true,
  '2fdgdfgdfgdf.tk': true,
  '2hotforyou.net': true,
  '2mydns.com': true,
  '2net.us': true,
  '2prong.com': true,
  '2trom.com': true,
  '3000.it': true,
  '30minutemail.com': true,
  '30minutesmail.com': true,
  '3126.com': true,
  '321media.com': true,
  '33mail.com': true,
  '360.ru': true,
  '37.com': true,
  '3ammagazine.com': true,
  '3dmail.com': true,
  '3email.com': true,
  '3g.ua': true,
  '3mail.ga': true,
  '3trtretgfrfe.tk': true,
  '3xl.net': true,
  '444.net': true,
  '4email.com': true,
  '4email.net': true,
  '4gfdsgfdgfd.tk': true,
  '4mg.com': true,
  '4newyork.com': true,
  '4warding.com': true,
  '4warding.net': true,
  '4warding.org': true,
  '4x4fan.com': true,
  '4x4man.com': true,
  '50mail.com': true,
  '5fm.za.com': true,
  '5ghgfhfghfgh.tk': true,
  '5iron.com': true,
  '5star.com': true,
  '60minutemail.com': true,
  '6hjgjhgkilkj.tk': true,
  '6ip.us': true,
  '6mail.cf': true,
  '6paq.com': true,
  '702mail.co.za': true,
  '74.ru': true,
  '7mail.ga': true,
  '7mail.ml': true,
  '7tags.com': true,
  '88.am': true,
  '8848.net': true,
  '888.nu': true,
  '8mail.ga': true,
  '8mail.ml': true,
  '97rock.com': true,
  '99experts.com': true,
  '9ox.net': true,
  'a-bc.net': true,
  'a-player.org': true,
  'a2z4u.net': true,
  'a45.in': true,
  'aaamail.zzn.com': true,
  'aahlife.com': true,
  'aamail.net': true,
  'aapt.net.au': true,
  'aaronkwok.net': true,
  'abbeyroadlondon.co.uk': true,
  'abcflash.net': true,
  'abdulnour.com': true,
  'aberystwyth.com': true,
  'abolition-now.com': true,
  'about.com': true,
  'absolutevitality.com': true,
  'abusemail.de': true,
  'abv.bg': true,
  'abwesend.de': true,
  'abyssmail.com': true,
  'ac20mail.in': true,
  'academycougars.com': true,
  'acceso.or.cr': true,
  'access4less.net': true,
  'accessgcc.com': true,
  'accountant.com': true,
  'acdcfan.com': true,
  'acdczone.com': true,
  'ace-of-base.com': true,
  'acmecity.com': true,
  'acmemail.net': true,
  'acninc.net': true,
  'acrobatmail.com': true,
  'activatormail.com': true,
  'activist.com': true,
  'adam.com.au': true,
  'add3000.pp.ua': true,
  'addcom.de': true,
  'address.com': true,
  'adelphia.net': true,
  'adexec.com': true,
  'adfarrow.com': true,
  'adinet.com.uy': true,
  'adios.net': true,
  'admin.in.th': true,
  'administrativos.com': true,
  'adoption.com': true,
  'ados.fr': true,
  'adrenalinefreak.com': true,
  'adres.nl': true,
  'advalvas.be': true,
  'advantimo.com': true,
  'aeiou.pt': true,
  'aemail4u.com': true,
  'aeneasmail.com': true,
  'afreeinternet.com': true,
  'africa-11.com': true,
  'africamail.com': true,
  'africamel.net': true,
  'africanpartnersonline.com': true,
  'afrobacon.com': true,
  'ag.us.to': true,
  'agedmail.com': true,
  'agelessemail.com': true,
  'agoodmail.com': true,
  'ahaa.dk': true,
  'ahk.jp': true,
  'aichi.com': true,
  'aim.com': true,
  'aircraftmail.com': true,
  'airforce.net': true,
  'airforceemail.com': true,
  'airpost.net': true,
  'aiutamici.com': true,
  'ajacied.com': true,
  'ajaxapp.net': true,
  'ak47.hu': true,
  'aknet.kg': true,
  'akphantom.com': true,
  'albawaba.com': true,
  'alecsmail.com': true,
  'alex4all.com': true,
  'alexandria.cc': true,
  'algeria.com': true,
  'algeriamail.com': true,
  'alhilal.net': true,
  'alibaba.com': true,
  'alice.it': true,
  'aliceadsl.fr': true,
  'aliceinchainsmail.com': true,
  'alivance.com': true,
  'alive.cz': true,
  'aliyun.com': true,
  'allergist.com': true,
  'allmail.net': true,
  'alloymail.com': true,
  'allracing.com': true,
  'allsaintsfan.com': true,
  'alltel.net': true,
  'alpenjodel.de': true,
  'alphafrau.de': true,
  'alskens.dk': true,
  'altavista.com': true,
  'altavista.net': true,
  'altavista.se': true,
  'alternativagratis.com': true,
  'alumni.com': true,
  'alumnidirector.com': true,
  'alvilag.hu': true,
  'ama-trade.de': true,
  'amail.com': true,
  'amazonses.com': true,
  'amele.com': true,
  'america.hm': true,
  'ameritech.net': true,
  'amilegit.com': true,
  'amiri.net': true,
  'amiriindustries.com': true,
  'amnetsal.com': true,
  'amorki.pl': true,
  'amrer.net': true,
  'amuro.net': true,
  'amuromail.com': true,
  'ananzi.co.za': true,
  'ancestry.com': true,
  'andreabocellimail.com': true,
  'andylau.net': true,
  'anfmail.com': true,
  'angelfan.com': true,
  'angelfire.com': true,
  'angelic.com': true,
  'animail.net': true,
  'animal.net': true,
  'animalhouse.com': true,
  'animalwoman.net': true,
  'anjungcafe.com': true,
  'anniefans.com': true,
  'annsmail.com': true,
  'ano-mail.net': true,
  'anonmails.de': true,
  'anonymbox.com': true,
  'anonymous.to': true,
  'anote.com': true,
  'another.com': true,
  'anotherdomaincyka.tk': true,
  'anotherwin95.com': true,
  'anti-ignorance.net': true,
  'anti-social.com': true,
  'antichef.com': true,
  'antichef.net': true,
  'antiqueemail.com': true,
  'antireg.ru': true,
  'antisocial.com': true,
  'antispam.de': true,
  'antispam24.de': true,
  'antispammail.de': true,
  'antongijsen.com': true,
  'antwerpen.com': true,
  'anymoment.com': true,
  'anytimenow.com': true,
  'aol.co.uk': true,
  'aol.com': true,
  'aol.de': true,
  'aol.fr': true,
  'aol.it': true,
  'aol.jp': true,
  'aon.at': true,
  'apexmail.com': true,
  'apmail.com': true,
  'apollo.lv': true,
  'aport.ru': true,
  'aport2000.ru': true,
  'apple.sib.ru': true,
  'appraiser.net': true,
  'approvers.net': true,
  'aquaticmail.net': true,
  'arabia.com': true,
  'arabtop.net': true,
  'arcademaster.com': true,
  'archaeologist.com': true,
  'archerymail.com': true,
  'arcor.de': true,
  'arcotronics.bg': true,
  'arcticmail.com': true,
  'argentina.com': true,
  'arhaelogist.com': true,
  'aristotle.org': true,
  'army.net': true,
  'armyspy.com': true,
  'arnet.com.ar': true,
  'art-en-ligne.pro': true,
  'artistemail.com': true,
  'artlover.com': true,
  'artlover.com.au': true,
  'artman-conception.com': true,
  'as-if.com': true,
  'asdasd.nl': true,
  'asean-mail': true,
  'asean-mail.com': true,
  'asheville.com': true,
  'asia-links.com': true,
  'asia-mail.com': true,
  'asia.com': true,
  'asiafind.com': true,
  'asianavenue.com': true,
  'asiancityweb.com': true,
  'asiansonly.net': true,
  'asianwired.net': true,
  'asiapoint.net': true,
  'askaclub.ru': true,
  'ass.pp.ua': true,
  'assala.com': true,
  'assamesemail.com': true,
  'astroboymail.com': true,
  'astrolover.com': true,
  'astrosfan.com': true,
  'astrosfan.net': true,
  'asurfer.com': true,
  'atheist.com': true,
  'athenachu.net': true,
  'atina.cl': true,
  'atl.lv': true,
  'atlas.cz': true,
  'atlaswebmail.com': true,
  'atlink.com': true,
  'atmc.net': true,
  'ato.check.com': true,
  'atozasia.com': true,
  'atrus.ru': true,
  'att.net': true,
  'attglobal.net': true,
  'attymail.com': true,
  'au.ru': true,
  'auctioneer.net': true,
  'aufeminin.com': true,
  'aus-city.com': true,
  'ausi.com': true,
  'aussiemail.com.au': true,
  'austin.rr.com': true,
  'australia.edu': true,
  'australiamail.com': true,
  'austrosearch.net': true,
  'autoescuelanerja.com': true,
  'autograf.pl': true,
  'automail.ru': true,
  'automotiveauthority.com': true,
  'autorambler.ru': true,
  'aver.com': true,
  'avh.hu': true,
  'avia-tonic.fr': true,
  'avtoritet.ru': true,
  'awayonvacation.com': true,
  'awholelotofamechi.com': true,
  'awsom.net': true,
  'axoskate.com': true,
  'ayna.com': true,
  'azazazatashkent.tk': true,
  'azimiweb.com': true,
  'azmeil.tk': true,
  'bachelorboy.com': true,
  'bachelorgal.com': true,
  'backfliper.com': true,
  'backpackers.com': true,
  'backstreet-boys.com': true,
  'backstreetboysclub.com': true,
  'backtothefuturefans.com': true,
  'backwards.com': true,
  'badtzmail.com': true,
  'bagherpour.com': true,
  'bahrainmail.com': true,
  'bakpaka.com': true,
  'bakpaka.net': true,
  'baldmama.de': true,
  'baldpapa.de': true,
  'ballerstatus.net': true,
  'ballyfinance.com': true,
  'balochistan.org': true,
  'baluch.com': true,
  'bangkok.com': true,
  'bangkok2000.com': true,
  'bannertown.net': true,
  'baptistmail.com': true,
  'baptized.com': true,
  'barcelona.com': true,
  'bareed.ws': true,
  'barid.com': true,
  'barlick.net': true,
  'bartender.net': true,
  'baseball-email.com': true,
  'baseballmail.com': true,
  'basketballmail.com': true,
  'batuta.net': true,
  'baudoinconsulting.com': true,
  'baxomale.ht.cx': true,
  'bboy.com': true,
  'bboy.zzn.com': true,
  'bcvibes.com': true,
  'beddly.com': true,
  'beeebank.com': true,
  'beefmilk.com': true,
  'beenhad.com': true,
  'beep.ru': true,
  'beer.com': true,
  'beerandremotes.com': true,
  'beethoven.com': true,
  'beirut.com': true,
  'belice.com': true,
  'belizehome.com': true,
  'belizemail.net': true,
  'belizeweb.com': true,
  'bell.net': true,
  'bellair.net': true,
  'bellsouth.net': true,
  'berkscounty.com': true,
  'berlin.com': true,
  'berlin.de': true,
  'berlinexpo.de': true,
  'bestmail.us': true,
  'betriebsdirektor.de': true,
  'bettergolf.net': true,
  'bharatmail.com': true,
  'big1.us': true,
  'big5mail.com': true,
  'bigassweb.com': true,
  'bigblue.net.au': true,
  'bigboab.com': true,
  'bigfoot.com': true,
  'bigfoot.de': true,
  'bigger.com': true,
  'biggerbadder.com': true,
  'bigmailbox.com': true,
  'bigmir.net': true,
  'bigpond.au': true,
  'bigpond.com': true,
  'bigpond.com.au': true,
  'bigpond.net': true,
  'bigpond.net.au': true,
  'bigramp.com': true,
  'bigstring.com': true,
  'bikemechanics.com': true,
  'bikeracer.com': true,
  'bikeracers.net': true,
  'bikerider.com': true,
  'billsfan.com': true,
  'billsfan.net': true,
  'bimamail.com': true,
  'bimla.net': true,
  'bin-wieder-da.de': true,
  'binkmail.com': true,
  'bio-muesli.info': true,
  'bio-muesli.net': true,
  'biologyfan.com': true,
  'birdfanatic.com': true,
  'birdlover.com': true,
  'birdowner.net': true,
  'bisons.com': true,
  'bitmail.com': true,
  'bitpage.net': true,
  'bizhosting.com': true,
  'bk.ru': true,
  'bkkmail.com': true,
  'bla-bla.com': true,
  'blackburnfans.com': true,
  'blackburnmail.com': true,
  'blackplanet.com': true,
  'blader.com': true,
  'bladesmail.net': true,
  'blazemail.com': true,
  'bleib-bei-mir.de': true,
  'blink182.net': true,
  'blockfilter.com': true,
  'blogmyway.org': true,
  'blondandeasy.com': true,
  'bluebottle.com': true,
  'bluehyppo.com': true,
  'bluemail.ch': true,
  'bluemail.dk': true,
  'bluesfan.com': true,
  'bluewin.ch': true,
  'blueyonder.co.uk': true,
  'blumail.org': true,
  'blushmail.com': true,
  'blutig.me': true,
  'bmlsports.net': true,
  'boardermail.com': true,
  'boarderzone.com': true,
  'boatracers.com': true,
  'bobmail.info': true,
  'bodhi.lawlita.com': true,
  'bofthew.com': true,
  'bol.com.br': true,
  'bolando.com': true,
  'bollywoodz.com': true,
  'bolt.com': true,
  'boltonfans.com': true,
  'bombdiggity.com': true,
  'bonbon.net': true,
  'boom.com': true,
  'bootmail.com': true,
  'bootybay.de': true,
  'bornagain.com': true,
  'bornnaked.com': true,
  'bossofthemoss.com': true,
  'bostonoffice.com': true,
  'boun.cr': true,
  'bounce.net': true,
  'bounces.amazon.com': true,
  'bouncr.com': true,
  'box.az': true,
  'box.ua': true,
  'boxbg.com': true,
  'boxemail.com': true,
  'boxformail.in': true,
  'boxfrog.com': true,
  'boximail.com': true,
  'boyzoneclub.com': true,
  'bradfordfans.com': true,
  'brasilia.net': true,
  'bratan.ru': true,
  'brazilmail.com': true,
  'brazilmail.com.br': true,
  'breadtimes.press': true,
  'breakthru.com': true,
  'breathe.com': true,
  'brefmail.com': true,
  'brennendesreich.de': true,
  'bresnan.net': true,
  'brestonline.com': true,
  'brew-master.com': true,
  'brew-meister.com': true,
  'brfree.com.br': true,
  'briefemail.com': true,
  'bright.net': true,
  'britneyclub.com': true,
  'brittonsign.com': true,
  'broadcast.net': true,
  'broadwaybuff.com': true,
  'broadwaylove.com': true,
  'brokeandhappy.com': true,
  'brokenvalve.com': true,
  'brujula.net': true,
  'brunetka.ru': true,
  'brusseler.com': true,
  'bsdmail.com': true,
  'bsnow.net': true,
  'bspamfree.org': true,
  'bt.com': true,
  'btcc.org': true,
  'btcmail.pw': true,
  'btconnect.co.uk': true,
  'btconnect.com': true,
  'btinternet.com': true,
  'btopenworld.co.uk': true,
  'buerotiger.de': true,
  'buffymail.com': true,
  'bugmenot.com': true,
  'bulgaria.com': true,
  'bullsfan.com': true,
  'bullsgame.com': true,
  'bumerang.ro': true,
  'bumpymail.com': true,
  'bumrap.com': true,
  'bund.us': true,
  'bunita.net': true,
  'bunko.com': true,
  'burnthespam.info': true,
  'burntmail.com': true,
  'burstmail.info': true,
  'buryfans.com': true,
  'bushemail.com': true,
  'business-man.com': true,
  'businessman.net': true,
  'businessweekmail.com': true,
  'bust.com': true,
  'busta-rhymes.com': true,
  'busymail.com': true,
  'busymail.com.com': true,
  'busymail.comhomeart.com': true,
  'butch-femme.net': true,
  'butovo.net': true,
  'buyersusa.com': true,
  'buymoreplays.com': true,
  'buzy.com': true,
  'bvimailbox.com': true,
  'byke.com': true,
  'byom.de': true,
  'byteme.com': true,
  'c2.hu': true,
  'c2i.net': true,
  'c3.hu': true,
  'c4.com': true,
  'c51vsgq.com': true,
  'cabacabana.com': true,
  'cable.comcast.com': true,
  'cableone.net': true,
  'caere.it': true,
  'cairomail.com': true,
  'calcuttaads.com': true,
  'calendar-server.bounces.google.com': true,
  'calidifontain.be': true,
  'californiamail.com': true,
  'callnetuk.com': true,
  'callsign.net': true,
  'caltanet.it': true,
  'camidge.com': true,
  'canada-11.com': true,
  'canada.com': true,
  'canadianmail.com': true,
  'canoemail.com': true,
  'cantv.net': true,
  'canwetalk.com': true,
  'caramail.com': true,
  'card.zp.ua': true,
  'care2.com': true,
  'careceo.com': true,
  'careerbuildermail.com': true,
  'carioca.net': true,
  'cartelera.org': true,
  'cartestraina.ro': true,
  'casablancaresort.com': true,
  'casema.nl': true,
  'cash4u.com': true,
  'cashette.com': true,
  'casino.com': true,
  'casualdx.com': true,
  'cataloniamail.com': true,
  'cataz.com': true,
  'catcha.com': true,
  'catchamail.com': true,
  'catemail.com': true,
  'catholic.org': true,
  'catlover.com': true,
  'catsrule.garfield.com': true,
  'ccnmail.com': true,
  'cd2.com': true,
  'cek.pm': true,
  'celineclub.com': true,
  'celtic.com': true,
  'center-mail.de': true,
  'centermail.at': true,
  'centermail.com': true,
  'centermail.de': true,
  'centermail.info': true,
  'centermail.net': true,
  'centoper.it': true,
  'centralpets.com': true,
  'centrum.cz': true,
  'centrum.sk': true,
  'centurylink.net': true,
  'centurytel.net': true,
  'certifiedmail.com': true,
  'cfl.rr.com': true,
  'cgac.es': true,
  'cghost.s-a-d.de': true,
  'chacuo.net': true,
  'chaiyo.com': true,
  'chaiyomail.com': true,
  'chalkmail.net': true,
  'chammy.info': true,
  'chance2mail.com': true,
  'chandrasekar.net': true,
  'channelonetv.com': true,
  'charityemail.com': true,
  'charmedmail.com': true,
  'charter.com': true,
  'charter.net': true,
  'chat.ru': true,
  'chatlane.ru': true,
  'chattown.com': true,
  'chauhanweb.com': true,
  'cheatmail.de': true,
  'chechnya.conf.work': true,
  'check.com': true,
  'check.com12': true,
  'check1check.com': true,
  'cheeb.com': true,
  'cheerful.com': true,
  'chef.net': true,
  'chefmail.com': true,
  'chek.com': true,
  'chello.nl': true,
  'chemist.com': true,
  'chequemail.com': true,
  'cheshiremail.com': true,
  'cheyenneweb.com': true,
  'chez.com': true,
  'chickmail.com': true,
  'chil-e.com': true,
  'childrens.md': true,
  'childsavetrust.org': true,
  'china.com': true,
  'china.net.vg': true,
  'chinalook.com': true,
  'chinamail.com': true,
  'chinesecool.com': true,
  'chirk.com': true,
  'chocaholic.com.au': true,
  'chocofan.com': true,
  'chogmail.com': true,
  'choicemail1.com': true,
  'chong-mail.com': true,
  'chong-mail.net': true,
  'christianmail.net': true,
  'chronicspender.com': true,
  'churchusa.com': true,
  'cia-agent.com': true,
  'cia.hu': true,
  'ciaoweb.it': true,
  'cicciociccio.com': true,
  'cincinow.net': true,
  'cirquefans.com': true,
  'citeweb.net': true,
  'citiz.net': true,
  'citlink.net': true,
  'city-of-bath.org': true,
  'city-of-birmingham.com': true,
  'city-of-brighton.org': true,
  'city-of-cambridge.com': true,
  'city-of-coventry.com': true,
  'city-of-edinburgh.com': true,
  'city-of-lichfield.com': true,
  'city-of-lincoln.com': true,
  'city-of-liverpool.com': true,
  'city-of-manchester.com': true,
  'city-of-nottingham.com': true,
  'city-of-oxford.com': true,
  'city-of-swansea.com': true,
  'city-of-westminster.com': true,
  'city-of-westminster.net': true,
  'city-of-york.net': true,
  'city2city.com': true,
  'citynetusa.com': true,
  'cityofcardiff.net': true,
  'cityoflondon.org': true,
  'ciudad.com.ar': true,
  'ckaazaza.tk': true,
  'claramail.com': true,
  'classicalfan.com': true,
  'classicmail.co.za': true,
  'clear.net.nz': true,
  'clearwire.net': true,
  'clerk.com': true,
  'clickforadate.com': true,
  'cliffhanger.com': true,
  'clixser.com': true,
  'close2you.ne': true,
  'close2you.net': true,
  'clrmail.com': true,
  'club-internet.fr': true,
  'club4x4.net': true,
  'clubalfa.com': true,
  'clubbers.net': true,
  'clubducati.com': true,
  'clubhonda.net': true,
  'clubmember.org': true,
  'clubnetnoir.com': true,
  'clubvdo.net': true,
  'cluemail.com': true,
  'cmail.net': true,
  'cmail.org': true,
  'cmail.ru': true,
  'cmpmail.com': true,
  'cmpnetmail.com': true,
  'cnegal.com': true,
  'cnnsimail.com': true,
  'cntv.cn': true,
  'codec.ro': true,
  'codec.ro.ro': true,
  'codec.roemail.ro': true,
  'coder.hu': true,
  'coid.biz': true,
  'coldemail.info': true,
  'coldmail.com': true,
  'collectiblesuperstore.com': true,
  'collector.org': true,
  'collegebeat.com': true,
  'collegeclub.com': true,
  'collegemail.com': true,
  'colleges.com': true,
  'columbus.rr.com': true,
  'columbusrr.com': true,
  'columnist.com': true,
  'comast.com': true,
  'comast.net': true,
  'comcast.com': true,
  'comcast.net': true,
  'comic.com': true,
  'communityconnect.com': true,
  'complxmind.com': true,
  'comporium.net': true,
  'comprendemail.com': true,
  'compuserve.com': true,
  'computer-expert.net': true,
  'computer-freak.com': true,
  'computer4u.com': true,
  'computerconfused.com': true,
  'computermail.net': true,
  'computernaked.com': true,
  'conexcol.com': true,
  'cong.ru': true,
  'conk.com': true,
  'connect4free.net': true,
  'connectbox.com': true,
  'conok.com': true,
  'consultant.com': true,
  'consumerriot.com': true,
  'contractor.net': true,
  'contrasto.cu.cc': true,
  'cookiemonster.com': true,
  'cool.br': true,
  'cool.fr.nf': true,
  'coole-files.de': true,
  'coolgoose.ca': true,
  'coolgoose.com': true,
  'coolkiwi.com': true,
  'coollist.com': true,
  'coolmail.com': true,
  'coolmail.net': true,
  'coolrio.com': true,
  'coolsend.com': true,
  'coolsite.net': true,
  'cooooool.com': true,
  'cooperation.net': true,
  'cooperationtogo.net': true,
  'copacabana.com': true,
  'copper.net': true,
  'copticmail.com': true,
  'cornells.com': true,
  'cornerpub.com': true,
  'corporatedirtbag.com': true,
  'correo.terra.com.gt': true,
  'corrsfan.com': true,
  'cortinet.com': true,
  'cosmo.com': true,
  'cotas.net': true,
  'counsellor.com': true,
  'countrylover.com': true,
  'courriel.fr.nf': true,
  'courrieltemporaire.com': true,
  'cox.com': true,
  'cox.net': true,
  'coxinet.net': true,
  'cpaonline.net': true,
  'cracker.hu': true,
  'craftemail.com': true,
  'crapmail.org': true,
  'crazedanddazed.com': true,
  'crazy.ru': true,
  'crazymailing.com': true,
  'crazysexycool.com': true,
  'crewstart.com': true,
  'cristianemail.com': true,
  'critterpost.com': true,
  'croeso.com': true,
  'crosshairs.com': true,
  'crosswinds.net': true,
  'crunkmail.com': true,
  'crwmail.com': true,
  'cry4helponline.com': true,
  'cryingmail.com': true,
  'cs.com': true,
  'csinibaba.hu': true,
  'cubiclink.com': true,
  'cuemail.com': true,
  'cumbriamail.com': true,
  'curio-city.com': true,
  'curryworld.de': true,
  'curtsmail.com': true,
  'cust.in': true,
  'cute-girl.com': true,
  'cuteandcuddly.com': true,
  'cutekittens.com': true,
  'cutey.com': true,
  'cuvox.de': true,
  'cww.de': true,
  'cyber-africa.net': true,
  'cyber-innovation.club': true,
  'cyber-matrix.com': true,
  'cyber-phone.eu': true,
  'cyber-wizard.com': true,
  'cyber4all.com': true,
  'cyberbabies.com': true,
  'cybercafemaui.com': true,
  'cybercity-online.net': true,
  'cyberdude.com': true,
  'cyberforeplay.net': true,
  'cybergal.com': true,
  'cybergrrl.com': true,
  'cyberinbox.com': true,
  'cyberleports.com': true,
  'cybermail.net': true,
  'cybernet.it': true,
  'cyberservices.com': true,
  'cyberspace-asia.com': true,
  'cybertrains.org': true,
  'cyclefanz.com': true,
  'cymail.net': true,
  'cynetcity.com': true,
  'd3p.dk': true,
  'dabsol.net': true,
  'dacoolest.com': true,
  'dadacasa.com': true,
  'daha.com': true,
  'dailypioneer.com': true,
  'dallas.theboys.com': true,
  'dallasmail.com': true,
  'dandikmail.com': true,
  'dangerous-minds.com': true,
  'dansegulvet.com': true,
  'dasdasdascyka.tk': true,
  'data54.com': true,
  'date.by': true,
  'daum.net': true,
  'davegracey.com': true,
  'dawnsonmail.com': true,
  'dawsonmail.com': true,
  'dayrep.com': true,
  'dazedandconfused.com': true,
  'dbzmail.com': true,
  'dcemail.com': true,
  'dcsi.net': true,
  'ddns.org': true,
  'deadaddress.com': true,
  'deadlymob.org': true,
  'deadspam.com': true,
  'deafemail.net': true,
  'deagot.com': true,
  'deal-maker.com': true,
  'dearriba.com': true,
  'death-star.com': true,
  'deepseafisherman.net': true,
  'deforestationsucks.com': true,
  'degoo.com': true,
  'dejanews.com': true,
  'delikkt.de': true,
  'deliveryman.com': true,
  'deneg.net': true,
  'depechemode.com': true,
  'deseretmail.com': true,
  'desertmail.com': true,
  'desertonline.com': true,
  'desertsaintsmail.com': true,
  'desilota.com': true,
  'deskmail.com': true,
  'deskpilot.com': true,
  'despam.it': true,
  'despammed.com': true,
  'destin.com': true,
  'detik.com': true,
  'deutschland-net.com': true,
  'devnullmail.com': true,
  'devotedcouples.com': true,
  'dezigner.ru': true,
  'dfgh.net': true,
  'dfwatson.com': true,
  'dglnet.com.br': true,
  'dgoh.org': true,
  'di-ve.com': true,
  'diamondemail.com': true,
  'didamail.com': true,
  'die-besten-bilder.de': true,
  'die-genossen.de': true,
  'die-optimisten.de': true,
  'die-optimisten.net': true,
  'die.life': true,
  'diehardmail.com': true,
  'diemailbox.de': true,
  'digibel.be': true,
  'digital-filestore.de': true,
  'digitalforeplay.net': true,
  'digitalsanctuary.com': true,
  'digosnet.com': true,
  'dingbone.com': true,
  'diplomats.com': true,
  'directbox.com': true,
  'director-general.com': true,
  'diri.com': true,
  'dirtracer.com': true,
  'dirtracers.com': true,
  'discard.email': true,
  'discard.ga': true,
  'discard.gq': true,
  'discardmail.com': true,
  'discardmail.de': true,
  'disciples.com': true,
  'discofan.com': true,
  'discovery.com': true,
  'discoverymail.com': true,
  'discoverymail.net': true,
  'disign-concept.eu': true,
  'disign-revelation.com': true,
  'disinfo.net': true,
  'dispomail.eu': true,
  'disposable.com': true,
  'disposableaddress.com': true,
  'disposableemailaddresses.com': true,
  'disposableinbox.com': true,
  'dispose.it': true,
  'dispostable.com': true,
  'divismail.ru': true,
  'divorcedandhappy.com': true,
  'dm.w3internet.co.uk': true,
  'dmailman.com': true,
  'dmitrovka.net': true,
  'dmitry.ru': true,
  'dnainternet.net': true,
  'dnsmadeeasy.com': true,
  'doar.net': true,
  'doclist.bounces.google.com': true,
  'docmail.cz': true,
  'docs.google.com': true,
  'doctor.com': true,
  'dodgeit.com': true,
  'dodgit.com': true,
  'dodgit.org': true,
  'dodo.com.au': true,
  'dodsi.com': true,
  'dog.com': true,
  'dogit.com': true,
  'doglover.com': true,
  'dogmail.co.uk': true,
  'dogsnob.net': true,
  'doityourself.com': true,
  'domforfb1.tk': true,
  'domforfb2.tk': true,
  'domforfb3.tk': true,
  'domforfb4.tk': true,
  'domforfb5.tk': true,
  'domforfb6.tk': true,
  'domforfb7.tk': true,
  'domforfb8.tk': true,
  'domozmail.com': true,
  'doneasy.com': true,
  'donegal.net': true,
  'donemail.ru': true,
  'donjuan.com': true,
  'dontgotmail.com': true,
  'dontmesswithtexas.com': true,
  'dontreg.com': true,
  'dontsendmespam.de': true,
  'doramail.com': true,
  'dostmail.com': true,
  'dotcom.fr': true,
  'dotmsg.com': true,
  'dotnow.com': true,
  'dott.it': true,
  'download-privat.de': true,
  'dplanet.ch': true,
  'dr.com': true,
  'dragoncon.net': true,
  'dragracer.com': true,
  'drdrb.net': true,
  'drivehq.com': true,
  'dropmail.me': true,
  'dropzone.com': true,
  'drotposta.hu': true,
  'dubaimail.com': true,
  'dublin.com': true,
  'dublin.ie': true,
  'dump-email.info': true,
  'dumpandjunk.com': true,
  'dumpmail.com': true,
  'dumpmail.de': true,
  'dumpyemail.com': true,
  'dunlopdriver.com': true,
  'dunloprider.com': true,
  'duno.com': true,
  'duskmail.com': true,
  'dustdevil.com': true,
  'dutchmail.com': true,
  'dvd-fan.net': true,
  'dwp.net': true,
  'dygo.com': true,
  'dynamitemail.com': true,
  'dyndns.org': true,
  'e-apollo.lv': true,
  'e-hkma.com': true,
  'e-mail.com': true,
  'e-mail.com.tr': true,
  'e-mail.dk': true,
  'e-mail.org': true,
  'e-mail.ru': true,
  'e-mail.ua': true,
  'e-mailanywhere.com': true,
  'e-mails.ru': true,
  'e-tapaal.com': true,
  'e-webtec.com': true,
  'e4ward.com': true,
  'earthalliance.com': true,
  'earthcam.net': true,
  'earthdome.com': true,
  'earthling.net': true,
  'earthlink.net': true,
  'earthonline.net': true,
  'eastcoast.co.za': true,
  'eastlink.ca': true,
  'eastmail.com': true,
  'eastrolog.com': true,
  'easy.com': true,
  'easy.to': true,
  'easypeasy.com': true,
  'easypost.com': true,
  'easytrashmail.com': true,
  'eatmydirt.com': true,
  'ebprofits.net': true,
  'ec.rr.com': true,
  'ecardmail.com': true,
  'ecbsolutions.net': true,
  'echina.com': true,
  'ecolo-online.fr': true,
  'ecompare.com': true,
  'edmail.com': true,
  'ednatx.com': true,
  'edtnmail.com': true,
  'educacao.te.pt': true,
  'educastmail.com': true,
  'eelmail.com': true,
  'ehmail.com': true,
  'einmalmail.de': true,
  'einrot.com': true,
  'einrot.de': true,
  'eintagsmail.de': true,
  'eircom.net': true,
  'ekidz.com.au': true,
  'elisanet.fi': true,
  'elitemail.org': true,
  'elsitio.com': true,
  'eltimon.com': true,
  'elvis.com': true,
  'elvisfan.com': true,
  'email-fake.gq': true,
  'email-london.co.uk': true,
  'email-value.com': true,
  'email.biz': true,
  'email.cbes.net': true,
  'email.com': true,
  'email.cz': true,
  'email.ee': true,
  'email.it': true,
  'email.nu': true,
  'email.org': true,
  'email.ro': true,
  'email.ru': true,
  'email.si': true,
  'email.su': true,
  'email.ua': true,
  'email.women.com': true,
  'email2me.com': true,
  'email2me.net': true,
  'email4u.info': true,
  'email60.com': true,
  'emailacc.com': true,
  'emailaccount.com': true,
  'emailaddresses.com': true,
  'emailage.ga': true,
  'emailage.gq': true,
  'emailasso.net': true,
  'emailchoice.com': true,
  'emailcorner.net': true,
  'emailem.com': true,
  'emailengine.net': true,
  'emailengine.org': true,
  'emailer.hubspot.com': true,
  'emailforyou.net': true,
  'emailgaul.com': true,
  'emailgo.de': true,
  'emailgroups.net': true,
  'emailias.com': true,
  'emailinfive.com': true,
  'emailit.com': true,
  'emaillime.com': true,
  'emailmiser.com': true,
  'emailoregon.com': true,
  'emailpinoy.com': true,
  'emailplanet.com': true,
  'emailplus.org': true,
  'emailproxsy.com': true,
  'emails.ga': true,
  'emails.incisivemedia.com': true,
  'emails.ru': true,
  'emailsensei.com': true,
  'emailservice.com': true,
  'emailsydney.com': true,
  'emailtemporanea.com': true,
  'emailtemporanea.net': true,
  'emailtemporar.ro': true,
  'emailtemporario.com.br': true,
  'emailthe.net': true,
  'emailtmp.com': true,
  'emailto.de': true,
  'emailuser.net': true,
  'emailwarden.com': true,
  'emailx.at.hm': true,
  'emailx.net': true,
  'emailxfer.com': true,
  'emailz.ga': true,
  'emailz.gq': true,
  'emale.ru': true,
  'ematic.com': true,
  'embarqmail.com': true,
  'emeil.in': true,
  'emeil.ir': true,
  'emil.com': true,
  'eml.cc': true,
  'eml.pp.ua': true,
  'empereur.com': true,
  'emptymail.com': true,
  'emumail.com': true,
  'emz.net': true,
  'end-war.com': true,
  'enel.net': true,
  'enelpunto.net': true,
  'engineer.com': true,
  'england.com': true,
  'england.edu': true,
  'englandmail.com': true,
  'epage.ru': true,
  'epatra.com': true,
  'ephemail.net': true,
  'epiqmail.com': true,
  'epix.net': true,
  'epomail.com': true,
  'epost.de': true,
  'eposta.hu': true,
  'eprompter.com': true,
  'eqqu.com': true,
  'eramail.co.za': true,
  'eresmas.com': true,
  'eriga.lv': true,
  'ero-tube.org': true,
  'eshche.net': true,
  'esmailweb.net': true,
  'estranet.it': true,
  'ethos.st': true,
  'etoast.com': true,
  'etrademail.com': true,
  'etranquil.com': true,
  'etranquil.net': true,
  'eudoramail.com': true,
  'europamel.net': true,
  'europe.com': true,
  'europemail.com': true,
  'euroseek.com': true,
  'eurosport.com': true,
  'evafan.com': true,
  'evertonfans.com': true,
  'every1.net': true,
  'everyday.com.kh': true,
  'everymail.net': true,
  'everyone.net': true,
  'everytg.ml': true,
  'evopo.com': true,
  'examnotes.net': true,
  'excite.co.jp': true,
  'excite.co.uk': true,
  'excite.com': true,
  'excite.it': true,
  'execs.com': true,
  'execs2k.com': true,
  'executivemail.co.za': true,
  'exemail.com.au': true,
  'exg6.exghost.com': true,
  'explodemail.com': true,
  'express.net.ua': true,
  'expressasia.com': true,
  'extenda.net': true,
  'extended.com': true,
  'extremail.ru': true,
  'eyepaste.com': true,
  'eyou.com': true,
  'ezagenda.com': true,
  'ezcybersearch.com': true,
  'ezmail.egine.com': true,
  'ezmail.ru': true,
  'ezrs.com': true,
  'f-m.fm': true,
  'f1fans.net': true,
  'facebook-email.ga': true,
  'facebook.com': true,
  'facebookmail.com': true,
  'facebookmail.gq': true,
  'fadrasha.net': true,
  'fadrasha.org': true,
  'fahr-zur-hoelle.org': true,
  'fake-email.pp.ua': true,
  'fake-mail.cf': true,
  'fake-mail.ga': true,
  'fake-mail.ml': true,
  'fakeinbox.com': true,
  'fakeinformation.com': true,
  'fakemailz.com': true,
  'falseaddress.com': true,
  'fan.com': true,
  'fan.theboys.com': true,
  'fannclub.com': true,
  'fansonlymail.com': true,
  'fansworldwide.de': true,
  'fantasticmail.com': true,
  'fantasymail.de': true,
  'farang.net': true,
  'farifluset.mailexpire.com': true,
  'faroweb.com': true,
  'fast-email.com': true,
  'fast-mail.fr': true,
  'fast-mail.org': true,
  'fastacura.com': true,
  'fastchevy.com': true,
  'fastchrysler.com': true,
  'fastem.com': true,
  'fastemail.us': true,
  'fastemailer.com': true,
  'fastemailextractor.net': true,
  'fastermail.com': true,
  'fastest.cc': true,
  'fastimap.com': true,
  'fastkawasaki.com': true,
  'fastmail.ca': true,
  'fastmail.cn': true,
  'fastmail.co.uk': true,
  'fastmail.com': true,
  'fastmail.com.au': true,
  'fastmail.es': true,
  'fastmail.fm': true,
  'fastmail.gr': true,
  'fastmail.im': true,
  'fastmail.in': true,
  'fastmail.jp': true,
  'fastmail.mx': true,
  'fastmail.net': true,
  'fastmail.nl': true,
  'fastmail.se': true,
  'fastmail.to': true,
  'fastmail.tw': true,
  'fastmail.us': true,
  'fastmailbox.net': true,
  'fastmazda.com': true,
  'fastmessaging.com': true,
  'fastmitsubishi.com': true,
  'fastnissan.com': true,
  'fastservice.com': true,
  'fastsubaru.com': true,
  'fastsuzuki.com': true,
  'fasttoyota.com': true,
  'fastyamaha.com': true,
  'fatcock.net': true,
  'fatflap.com': true,
  'fathersrightsne.org': true,
  'fatyachts.com': true,
  'fax.ru': true,
  'fbi-agent.com': true,
  'fbi.hu': true,
  'fdfdsfds.com': true,
  'fea.st': true,
  'federalcontractors.com': true,
  'feinripptraeger.de': true,
  'felicity.com': true,
  'felicitymail.com': true,
  'female.ru': true,
  'femenino.com': true,
  'fepg.net': true,
  'fetchmail.co.uk': true,
  'fetchmail.com': true,
  'fettabernett.de': true,
  'feyenoorder.com': true,
  'ffanet.com': true,
  'fiberia.com': true,
  'fibertel.com.ar': true,
  'ficken.de': true,
  'fificorp.com': true,
  'fificorp.net': true,
  'fightallspam.com': true,
  'filipinolinks.com': true,
  'filzmail.com': true,
  'financefan.net': true,
  'financemail.net': true,
  'financier.com': true,
  'findfo.com': true,
  'findhere.com': true,
  'findmail.com': true,
  'findmemail.com': true,
  'finebody.com': true,
  'fineemail.com': true,
  'finfin.com': true,
  'finklfan.com': true,
  'fire-brigade.com': true,
  'fireman.net': true,
  'fishburne.org': true,
  'fishfuse.com': true,
  'fivemail.de': true,
  'fixmail.tk': true,
  'fizmail.com': true,
  'flashbox.5july.org': true,
  'flashemail.com': true,
  'flashmail.com': true,
  'flashmail.net': true,
  'fleckens.hu': true,
  'flipcode.com': true,
  'floridaemail.net': true,
  'flytecrew.com': true,
  'fmail.co.uk': true,
  'fmailbox.com': true,
  'fmgirl.com': true,
  'fmguy.com': true,
  'fnbmail.co.za': true,
  'fnmail.com': true,
  'folkfan.com': true,
  'foodmail.com': true,
  'footard.com': true,
  'football.theboys.com': true,
  'footballmail.com': true,
  'foothills.net': true,
  'for-president.com': true,
  'force9.co.uk': true,
  'forfree.at': true,
  'forgetmail.com': true,
  'fornow.eu': true,
  'forpresident.com': true,
  'fortuncity.com': true,
  'fortunecity.com': true,
  'forum.dk': true,
  'fossefans.com': true,
  'foxmail.com': true,
  'fr33mail.info': true,
  'francefans.com': true,
  'francemel.fr': true,
  'frapmail.com': true,
  'free-email.ga': true,
  'free-online.net': true,
  'free-org.com': true,
  'free.com.pe': true,
  'free.fr': true,
  'freeaccess.nl': true,
  'freeaccount.com': true,
  'freeandsingle.com': true,
  'freebox.com': true,
  'freedom.usa.com': true,
  'freedomlover.com': true,
  'freefanmail.com': true,
  'freegates.be': true,
  'freeghana.com': true,
  'freelance-france.eu': true,
  'freeler.nl': true,
  'freemail.bozz.com': true,
  'freemail.c3.hu': true,
  'freemail.com.au': true,
  'freemail.com.pk': true,
  'freemail.de': true,
  'freemail.et': true,
  'freemail.gr': true,
  'freemail.hu': true,
  'freemail.it': true,
  'freemail.lt': true,
  'freemail.ms': true,
  'freemail.nl': true,
  'freemail.org.mk': true,
  'freemail.ru': true,
  'freemails.ga': true,
  'freemeil.gq': true,
  'freenet.de': true,
  'freenet.kg': true,
  'freeola.com': true,
  'freeola.net': true,
  'freeproblem.com': true,
  'freesbee.fr': true,
  'freeserve.co.uk': true,
  'freeservers.com': true,
  'freestamp.com': true,
  'freestart.hu': true,
  'freesurf.fr': true,
  'freesurf.nl': true,
  'freeuk.com': true,
  'freeuk.net': true,
  'freeukisp.co.uk': true,
  'freeweb.org': true,
  'freewebemail.com': true,
  'freeyellow.com': true,
  'freezone.co.uk': true,
  'fresnomail.com': true,
  'freudenkinder.de': true,
  'freundin.ru': true,
  'friction.net': true,
  'friendlydevices.com': true,
  'friendlymail.co.uk': true,
  'friends-cafe.com': true,
  'friendsfan.com': true,
  'from-africa.com': true,
  'from-america.com': true,
  'from-argentina.com': true,
  'from-asia.com': true,
  'from-australia.com': true,
  'from-belgium.com': true,
  'from-brazil.com': true,
  'from-canada.com': true,
  'from-china.net': true,
  'from-england.com': true,
  'from-europe.com': true,
  'from-france.net': true,
  'from-germany.net': true,
  'from-holland.com': true,
  'from-israel.com': true,
  'from-italy.net': true,
  'from-japan.net': true,
  'from-korea.com': true,
  'from-mexico.com': true,
  'from-outerspace.com': true,
  'from-russia.com': true,
  'from-spain.net': true,
  'fromalabama.com': true,
  'fromalaska.com': true,
  'fromarizona.com': true,
  'fromarkansas.com': true,
  'fromcalifornia.com': true,
  'fromcolorado.com': true,
  'fromconnecticut.com': true,
  'fromdelaware.com': true,
  'fromflorida.net': true,
  'fromgeorgia.com': true,
  'fromhawaii.net': true,
  'fromidaho.com': true,
  'fromillinois.com': true,
  'fromindiana.com': true,
  'frominter.net': true,
  'fromiowa.com': true,
  'fromjupiter.com': true,
  'fromkansas.com': true,
  'fromkentucky.com': true,
  'fromlouisiana.com': true,
  'frommaine.net': true,
  'frommaryland.com': true,
  'frommassachusetts.com': true,
  'frommiami.com': true,
  'frommichigan.com': true,
  'fromminnesota.com': true,
  'frommississippi.com': true,
  'frommissouri.com': true,
  'frommontana.com': true,
  'fromnebraska.com': true,
  'fromnevada.com': true,
  'fromnewhampshire.com': true,
  'fromnewjersey.com': true,
  'fromnewmexico.com': true,
  'fromnewyork.net': true,
  'fromnorthcarolina.com': true,
  'fromnorthdakota.com': true,
  'fromohio.com': true,
  'fromoklahoma.com': true,
  'fromoregon.net': true,
  'frompennsylvania.com': true,
  'fromrhodeisland.com': true,
  'fromru.com': true,
  'fromru.ru': true,
  'fromsouthcarolina.com': true,
  'fromsouthdakota.com': true,
  'fromtennessee.com': true,
  'fromtexas.com': true,
  'fromthestates.com': true,
  'fromutah.com': true,
  'fromvermont.com': true,
  'fromvirginia.com': true,
  'fromwashington.com': true,
  'fromwashingtondc.com': true,
  'fromwestvirginia.com': true,
  'fromwisconsin.com': true,
  'fromwyoming.com': true,
  'front.ru': true,
  'frontier.com': true,
  'frontiernet.net': true,
  'frostbyte.uk.net': true,
  'fsmail.net': true,
  'ftc-i.net': true,
  'ftml.net': true,
  'fuckingduh.com': true,
  'fudgerub.com': true,
  'fullmail.com': true,
  'funiran.com': true,
  'funkfan.com': true,
  'funky4.com': true,
  'fuorissimo.com': true,
  'furnitureprovider.com': true,
  'fuse.net': true,
  'fusemail.com': true,
  'fut.es': true,
  'fux0ringduh.com': true,
  'fwnb.com': true,
  'fxsmails.com': true,
  'fyii.de': true,
  'galamb.net': true,
  'galaxy5.com': true,
  'galaxyhit.com': true,
  'gamebox.com': true,
  'gamebox.net': true,
  'gamegeek.com': true,
  'games.com': true,
  'gamespotmail.com': true,
  'gamil.com': true,
  'gamil.com.au': true,
  'gamno.config.work': true,
  'garbage.com': true,
  'gardener.com': true,
  'garliclife.com': true,
  'gatwickemail.com': true,
  'gawab.com': true,
  'gay.com': true,
  'gaybrighton.co.uk': true,
  'gaza.net': true,
  'gazeta.pl': true,
  'gazibooks.com': true,
  'gci.net': true,
  'gdi.net': true,
  'gee-wiz.com': true,
  'geecities.com': true,
  'geek.com': true,
  'geek.hu': true,
  'geeklife.com': true,
  'gehensiemirnichtaufdensack.de': true,
  'gelitik.in': true,
  'gencmail.com': true,
  'general-hospital.com': true,
  'gentlemansclub.de': true,
  'genxemail.com': true,
  'geocities.com': true,
  'geography.net': true,
  'geologist.com': true,
  'geopia.com': true,
  'germanymail.com': true,
  'get.pp.ua': true,
  'get1mail.com': true,
  'get2mail.fr': true,
  'getairmail.cf': true,
  'getairmail.com': true,
  'getairmail.ga': true,
  'getairmail.gq': true,
  'getmails.eu': true,
  'getonemail.com': true,
  'getonemail.net': true,
  'gfxartist.ru': true,
  'gh2000.com': true,
  'ghanamail.com': true,
  'ghostmail.com': true,
  'ghosttexter.de': true,
  'giantmail.de': true,
  'giantsfan.com': true,
  'giga4u.de': true,
  'gigileung.org': true,
  'girl4god.com': true,
  'girlsundertheinfluence.com': true,
  'gishpuppy.com': true,
  'givepeaceachance.com': true,
  'glay.org': true,
  'glendale.net': true,
  'globalfree.it': true,
  'globalpagan.com': true,
  'globalsite.com.br': true,
  'globetrotter.net': true,
  'globo.com': true,
  'globomail.com': true,
  'gmail.co.za': true,
  'gmail.com': true,
  'gmail.com.au': true,
  'gmail.com.br': true,
  'gmail.ru': true,
  'gmial.com': true,
  'gmx.at': true,
  'gmx.ch': true,
  'gmx.co.uk': true,
  'gmx.com': true,
  'gmx.de': true,
  'gmx.fr': true,
  'gmx.li': true,
  'gmx.net': true,
  'gmx.us': true,
  'gnwmail.com': true,
  'go.com': true,
  'go.ro': true,
  'go.ru': true,
  'go2.com.py': true,
  'go2net.com': true,
  'go4.it': true,
  'gobrainstorm.net': true,
  'gocollege.com': true,
  'gocubs.com': true,
  'godmail.dk': true,
  'goemailgo.com': true,
  'gofree.co.uk': true,
  'gol.com': true,
  'goldenmail.ru': true,
  'goldmail.ru': true,
  'goldtoolbox.com': true,
  'golfemail.com': true,
  'golfilla.info': true,
  'golfmail.be': true,
  'gonavy.net': true,
  'gonuts4free.com': true,
  'goodnewsmail.com': true,
  'goodstick.com': true,
  'google.com': true,
  'googlegroups.com': true,
  'googlemail.com': true,
  'goosemoose.com': true,
  'goplay.com': true,
  'gorillaswithdirtyarmpits.com': true,
  'gorontalo.net': true,
  'gospelfan.com': true,
  'gothere.uk.com': true,
  'gotmail.com': true,
  'gotmail.net': true,
  'gotmail.org': true,
  'gotomy.com': true,
  'gotti.otherinbox.com': true,
  'govolsfan.com': true,
  'gportal.hu': true,
  'grabmail.com': true,
  'graduate.org': true,
  'graffiti.net': true,
  'gramszu.net': true,
  'grandmamail.com': true,
  'grandmasmail.com': true,
  'graphic-designer.com': true,
  'grapplers.com': true,
  'gratisweb.com': true,
  'great-host.in': true,
  'greenmail.net': true,
  'greensloth.com': true,
  'groupmail.com': true,
  'grr.la': true,
  'grungecafe.com': true,
  'gsrv.co.uk': true,
  'gtemail.net': true,
  'gtmc.net': true,
  'gua.net': true,
  'guerillamail.biz': true,
  'guerillamail.com': true,
  'guerrillamail.biz': true,
  'guerrillamail.com': true,
  'guerrillamail.de': true,
  'guerrillamail.info': true,
  'guerrillamail.net': true,
  'guerrillamail.org': true,
  'guerrillamailblock.com': true,
  'guessmail.com': true,
  'guju.net': true,
  'gurlmail.com': true,
  'gustr.com': true,
  'guy.com': true,
  'guy2.com': true,
  'guyanafriends.com': true,
  'gwhsgeckos.com': true,
  'gyorsposta.com': true,
  'gyorsposta.hu': true,
  'h-mail.us': true,
  'hab-verschlafen.de': true,
  'hablas.com': true,
  'habmalnefrage.de': true,
  'hacccc.com': true,
  'hackermail.com': true,
  'hackermail.net': true,
  'hailmail.net': true,
  'hairdresser.com': true,
  'hairdresser.net': true,
  'haltospam.com': true,
  'hamptonroads.com': true,
  'handbag.com': true,
  'handleit.com': true,
  'hang-ten.com': true,
  'hangglidemail.com': true,
  'hanmail.net': true,
  'happemail.com': true,
  'happycounsel.com': true,
  'happypuppy.com': true,
  'harakirimail.com': true,
  'haramamba.ru': true,
  'hardcorefreak.com': true,
  'hardyoungbabes.com': true,
  'hartbot.de': true,
  'hat-geld.de': true,
  'hatespam.org': true,
  'hawaii.rr.com': true,
  'hawaiiantel.net': true,
  'headbone.com': true,
  'healthemail.net': true,
  'heartthrob.com': true,
  'heavynoize.net': true,
  'heerschap.com': true,
  'heesun.net': true,
  'hehe.com': true,
  'hello.hu': true,
  'hello.net.au': true,
  'hello.to': true,
  'hellokitty.com': true,
  'helter-skelter.com': true,
  'hempseed.com': true,
  'herediano.com': true,
  'heremail.com': true,
  'herono1.com': true,
  'herp.in': true,
  'herr-der-mails.de': true,
  'hetnet.nl': true,
  'hewgen.ru': true,
  'hey.to': true,
  'hhdevel.com': true,
  'hideakifan.com': true,
  'hidemail.de': true,
  'hidzz.com': true,
  'highmilton.com': true,
  'highquality.com': true,
  'highveldmail.co.za': true,
  'hilarious.com': true,
  'hinduhome.com': true,
  'hingis.org': true,
  'hiphopfan.com': true,
  'hispavista.com': true,
  'hitmail.com': true,
  'hitmanrecords.com': true,
  'hitthe.net': true,
  'hkg.net': true,
  'hkstarphoto.com': true,
  'hmamail.com': true,
  'hochsitze.com': true,
  'hockeymail.com': true,
  'hollywoodkids.com': true,
  'home-email.com': true,
  'home.de': true,
  'home.nl': true,
  'home.no.net': true,
  'home.ro': true,
  'home.se': true,
  'homeart.com': true,
  'homelocator.com': true,
  'homemail.com': true,
  'homenetmail.com': true,
  'homeonthethrone.com': true,
  'homestead.com': true,
  'homeworkcentral.com': true,
  'honduras.com': true,
  'hongkong.com': true,
  'hookup.net': true,
  'hoopsmail.com': true,
  'hopemail.biz': true,
  'horrormail.com': true,
  'host-it.com.sg': true,
  'hot-mail.gq': true,
  'hot-shop.com': true,
  'hot-shot.com': true,
  'hot.ee': true,
  'hotbot.com': true,
  'hotbox.ru': true,
  'hotbrev.com': true,
  'hotcoolmail.com': true,
  'hotepmail.com': true,
  'hotfire.net': true,
  'hotletter.com': true,
  'hotlinemail.com': true,
  'hotmail.be': true,
  'hotmail.ca': true,
  'hotmail.ch': true,
  'hotmail.co': true,
  'hotmail.co.il': true,
  'hotmail.co.jp': true,
  'hotmail.co.nz': true,
  'hotmail.co.uk': true,
  'hotmail.co.za': true,
  'hotmail.com': true,
  'hotmail.com.ar': true,
  'hotmail.com.au': true,
  'hotmail.com.br': true,
  'hotmail.com.mx': true,
  'hotmail.com.tr': true,
  'hotmail.de': true,
  'hotmail.es': true,
  'hotmail.fi': true,
  'hotmail.fr': true,
  'hotmail.it': true,
  'hotmail.kg': true,
  'hotmail.kz': true,
  'hotmail.my': true,
  'hotmail.nl': true,
  'hotmail.ro': true,
  'hotmail.roor': true,
  'hotmail.ru': true,
  'hotpop.com': true,
  'hotpop3.com': true,
  'hotvoice.com': true,
  'housefan.com': true,
  housefancom: true,
  'housemail.com': true,
  'hsuchi.net': true,
  'html.tou.com': true,
  'hu2.ru': true,
  'hughes.net': true,
  'hulapla.de': true,
  'humanoid.net': true,
  'humanux.com': true,
  'humn.ws.gy': true,
  'humour.com': true,
  'hunsa.com': true,
  'hurting.com': true,
  'hush.com': true,
  'hushmail.com': true,
  'hypernautica.com': true,
  'i-connect.com': true,
  'i-france.com': true,
  'i-love-cats.com': true,
  'i-mail.com.au': true,
  'i-mailbox.net': true,
  'i-p.com': true,
  'i.am': true,
  'i.am.to': true,
  'i.amhey.to': true,
  'i.ua': true,
  'i12.com': true,
  'i2828.com': true,
  'i2pmail.org': true,
  'iam4msu.com': true,
  'iamawoman.com': true,
  'iamfinallyonline.com': true,
  'iamwaiting.com': true,
  'iamwasted.com': true,
  'iamyours.com': true,
  'icestorm.com': true,
  'ich-bin-verrueckt-nach-dir.de': true,
  'ich-will-net.de': true,
  'icloud.com': true,
  'icmsconsultants.com': true,
  'icq.com': true,
  'icqmail.com': true,
  'icrazy.com': true,
  'icu.md': true,
  'id-base.com': true,
  'id.ru': true,
  'ididitmyway.com': true,
  'idigjesus.com': true,
  'idirect.com': true,
  'ieatspam.eu': true,
  'ieatspam.info': true,
  'ieh-mail.de': true,
  'iespana.es': true,
  'ifoward.com': true,
  'ig.com.br': true,
  'ignazio.it': true,
  'ignmail.com': true,
  'ihateclowns.com': true,
  'ihateyoualot.info': true,
  'iheartspam.org': true,
  'iinet.net.au': true,
  'ijustdontcare.com': true,
  'ikbenspamvrij.nl': true,
  'ilkposta.com': true,
  'ilovechocolate.com': true,
  'ilovegiraffes.net': true,
  'ilovejesus.com': true,
  'ilovelionking.com': true,
  'ilovepokemonmail.com': true,
  'ilovethemovies.com': true,
  'ilovetocollect.net': true,
  'ilse.nl': true,
  'imaginemail.com': true,
  'imail.org': true,
  'imail.ru': true,
  'imailbox.com': true,
  'imails.info': true,
  'imap-mail.com': true,
  'imap.cc': true,
  'imapmail.org': true,
  'imel.org': true,
  'imgof.com': true,
  'imgv.de': true,
  'immo-gerance.info': true,
  'imneverwrong.com': true,
  'imposter.co.uk': true,
  'imstations.com': true,
  'imstressed.com': true,
  'imtoosexy.com': true,
  'in-box.net': true,
  'in2jesus.com': true,
  'iname.com': true,
  'inbax.tk': true,
  'inbound.plus': true,
  'inbox.com': true,
  'inbox.lv': true,
  'inbox.net': true,
  'inbox.ru': true,
  'inbox.si': true,
  'inboxalias.com': true,
  'inboxclean.com': true,
  'inboxclean.org': true,
  'incamail.com': true,
  'includingarabia.com': true,
  'incredimail.com': true,
  'indeedemail.com': true,
  'index.ua': true,
  'indexa.fr': true,
  'india.com': true,
  'indiatimes.com': true,
  'indo-mail.com': true,
  'indocities.com': true,
  'indomail.com': true,
  'indosat.net.id': true,
  'indus.ru': true,
  'indyracers.com': true,
  'inerted.com': true,
  'inet.com': true,
  'inet.net.au': true,
  'info-media.de': true,
  'info-radio.ml': true,
  'info.com': true,
  'info66.com': true,
  'infoapex.com': true,
  'infocom.zp.ua': true,
  'infohq.com': true,
  'infomail.es': true,
  'infomart.or.jp': true,
  'informaticos.com': true,
  'infospacemail.com': true,
  'infovia.com.ar': true,
  'inicia.es': true,
  'inmail.sk': true,
  'inmail24.com': true,
  'inmano.com': true,
  'inmynetwork.tk': true,
  'innocent.com': true,
  'inonesearch.com': true,
  'inorbit.com': true,
  'inoutbox.com': true,
  'insidebaltimore.net': true,
  'insight.rr.com': true,
  'inspectorjavert.com': true,
  'instant-mail.de': true,
  'instantemailaddress.com': true,
  'instantmail.fr': true,
  'instruction.com': true,
  'instructor.net': true,
  'insurer.com': true,
  'interburp.com': true,
  'interfree.it': true,
  'interia.pl': true,
  'interlap.com.ar': true,
  'intermail.co.il': true,
  'internet-club.com': true,
  'internet-e-mail.com': true,
  'internet-mail.org': true,
  'internet-police.com': true,
  'internetbiz.com': true,
  'internetdrive.com': true,
  'internetegypt.com': true,
  'internetemails.net': true,
  'internetmailing.net': true,
  'internode.on.net': true,
  'invalid.com': true,
  'investormail.com': true,
  'inwind.it': true,
  'iobox.com': true,
  'iobox.fi': true,
  'iol.it': true,
  'iol.pt': true,
  'iowaemail.com': true,
  'ip3.com': true,
  'ip4.pp.ua': true,
  'ip6.li': true,
  'ip6.pp.ua': true,
  'ipdeer.com': true,
  'ipex.ru': true,
  'ipoo.org': true,
  'iportalexpress.com': true,
  'iprimus.com.au': true,
  'iqemail.com': true,
  'irangate.net': true,
  'iraqmail.com': true,
  'ireland.com': true,
  'irelandmail.com': true,
  'irish2me.com': true,
  'irj.hu': true,
  'iroid.com': true,
  'iscooler.com': true,
  'isellcars.com': true,
  'iservejesus.com': true,
  'islamonline.net': true,
  'islandemail.net': true,
  'isleuthmail.com': true,
  'ismart.net': true,
  'isonfire.com': true,
  'isp9.net': true,
  'israelmail.com': true,
  'ist-allein.info': true,
  'ist-einmalig.de': true,
  'ist-ganz-allein.de': true,
  'ist-willig.de': true,
  'italymail.com': true,
  'itelefonica.com.br': true,
  'itloox.com': true,
  'itmom.com': true,
  'ivebeenframed.com': true,
  'ivillage.com': true,
  'iwan-fals.com': true,
  'iwi.net': true,
  'iwmail.com': true,
  'iwon.com': true,
  'izadpanah.com': true,
  'jabble.com': true,
  'jahoopa.com': true,
  'jakuza.hu': true,
  'japan.com': true,
  'jaydemail.com': true,
  'jazzandjava.com': true,
  'jazzfan.com': true,
  'jazzgame.com': true,
  'je-recycle.info': true,
  'jeanvaljean.com': true,
  'jerusalemmail.com': true,
  'jesusanswers.com': true,
  'jet-renovation.fr': true,
  'jetable.com': true,
  'jetable.de': true,
  'jetable.fr.nf': true,
  'jetable.net': true,
  'jetable.org': true,
  'jetable.pp.ua': true,
  'jetemail.net': true,
  'jewishmail.com': true,
  'jfkislanders.com': true,
  'jingjo.net': true,
  'jippii.fi': true,
  'jmail.co.za': true,
  'jnxjn.com': true,
  'job4u.com': true,
  'jobbikszimpatizans.hu': true,
  'joelonsoftware.com': true,
  'joinme.com': true,
  'jojomail.com': true,
  'jokes.com': true,
  'jordanmail.com': true,
  'journalist.com': true,
  'jourrapide.com': true,
  'jovem.te.pt': true,
  'joymail.com': true,
  'jpopmail.com': true,
  'jsrsolutions.com': true,
  'jubiimail.dk': true,
  'jump.com': true,
  'jumpy.it': true,
  'juniormail.com': true,
  'junk1e.com': true,
  'junkmail.com': true,
  'junkmail.gq': true,
  'juno.com': true,
  'justemail.net': true,
  'justicemail.com': true,
  'justmail.de': true,
  'justmailz.com': true,
  'justmarriedmail.com': true,
  'jwspamspy ': true,
  'k.ro': true,
  'kaazoo.com': true,
  'kabissa.org': true,
  'kaduku.net': true,
  'kaffeeschluerfer.com': true,
  'kaffeeschluerfer.de': true,
  'kaixo.com': true,
  'kalpoint.com': true,
  'kansascity.com': true,
  'kapoorweb.com': true,
  'karachian.com': true,
  'karachioye.com': true,
  'karbasi.com': true,
  'kasmail.com': true,
  'kaspop.com': true,
  'katamail.com': true,
  'kayafmmail.co.za': true,
  'kbjrmail.com': true,
  'kcks.com': true,
  'kebi.com': true,
  'keftamail.com': true,
  'keg-party.com': true,
  'keinpardon.de': true,
  'keko.com.ar': true,
  'kellychen.com': true,
  'keptprivate.com': true,
  'keromail.com': true,
  'kewpee.com': true,
  'keyemail.com': true,
  'kgb.hu': true,
  'khosropour.com': true,
  'kichimail.com': true,
  'kickassmail.com': true,
  'killamail.com': true,
  'killergreenmail.com': true,
  'killermail.com': true,
  'killmail.com': true,
  'killmail.net': true,
  'kimo.com': true,
  'kimsdisk.com': true,
  'kinglibrary.net': true,
  'kinki-kids.com': true,
  'kismail.ru': true,
  'kissfans.com': true,
  'kitemail.com': true,
  'kittymail.com': true,
  'kitznet.at': true,
  'kiwibox.com': true,
  'kiwitown.com': true,
  'klassmaster.com': true,
  'klassmaster.net': true,
  'klzlk.com': true,
  'km.ru': true,
  'kmail.com.au': true,
  'knol-power.nl': true,
  'koko.com': true,
  'kolumbus.fi': true,
  'kommespaeter.de': true,
  'konkovo.net': true,
  'konsul.ru': true,
  'konx.com': true,
  'korea.com': true,
  'koreamail.com': true,
  'kosino.net': true,
  'koszmail.pl': true,
  'kozmail.com': true,
  'kpnmail.nl': true,
  'kreditor.ru': true,
  'krim.ws': true,
  'krongthip.com': true,
  'krovatka.net': true,
  'krunis.com': true,
  'ksanmail.com': true,
  'ksee24mail.com': true,
  'kube93mail.com': true,
  'kukamail.com': true,
  'kulturbetrieb.info': true,
  'kumarweb.com': true,
  'kurzepost.de': true,
  'kuwait-mail.com': true,
  'kuzminki.net': true,
  'kyokodate.com': true,
  'kyokofukada.net': true,
  'l33r.eu': true,
  'la.com': true,
  'labetteraverouge.at': true,
  'lackmail.ru': true,
  'ladyfire.com': true,
  'ladymail.cz': true,
  'lagerlouts.com': true,
  'lags.us': true,
  'lahoreoye.com': true,
  'lakmail.com': true,
  'lamer.hu': true,
  'land.ru': true,
  'langoo.com': true,
  'lankamail.com': true,
  'laoeq.com': true,
  'laposte.net': true,
  'lass-es-geschehen.de': true,
  'last-chance.pro': true,
  'lastmail.co': true,
  'latemodels.com': true,
  'latinmail.com': true,
  'latino.com': true,
  'lavabit.com': true,
  'lavache.com': true,
  'law.com': true,
  'lawlita.com': true,
  'lawyer.com': true,
  'lazyinbox.com': true,
  'learn2compute.net': true,
  'lebanonatlas.com': true,
  'leeching.net': true,
  'leehom.net': true,
  'lefortovo.net': true,
  'legalactions.com': true,
  'legalrc.loan': true,
  'legislator.com': true,
  'legistrator.com': true,
  'lenta.ru': true,
  'leonlai.net': true,
  'letsgomets.net': true,
  'letterbox.com': true,
  'letterboxes.org': true,
  'letthemeatspam.com': true,
  'levele.com': true,
  'levele.hu': true,
  'lex.bg': true,
  'lexis-nexis-mail.com': true,
  'lhsdv.com': true,
  'lianozovo.net': true,
  'libero.it': true,
  'liberomail.com': true,
  'lick101.com': true,
  'liebt-dich.info': true,
  'lifebyfood.com': true,
  'link2mail.net': true,
  'linkmaster.com': true,
  'linktrader.com': true,
  'linuxfreemail.com': true,
  'linuxmail.org': true,
  'lionsfan.com.au': true,
  'liontrucks.com': true,
  'liquidinformation.net': true,
  'lissamail.com': true,
  'list.ru': true,
  'listomail.com': true,
  'litedrop.com': true,
  'literaturelover.com': true,
  'littleapple.com': true,
  'littleblueroom.com': true,
  'live.at': true,
  'live.be': true,
  'live.ca': true,
  'live.cl': true,
  'live.cn': true,
  'live.co.uk': true,
  'live.co.za': true,
  'live.com': true,
  'live.com.ar': true,
  'live.com.au': true,
  'live.com.mx': true,
  'live.com.my': true,
  'live.com.pt': true,
  'live.com.sg': true,
  'live.de': true,
  'live.dk': true,
  'live.fr': true,
  'live.hk': true,
  'live.ie': true,
  'live.in': true,
  'live.it': true,
  'live.jp': true,
  'live.nl': true,
  'live.no': true,
  'live.ru': true,
  'live.se': true,
  'liveradio.tk': true,
  'liverpoolfans.com': true,
  'ljiljan.com': true,
  'llandudno.com': true,
  'llangollen.com': true,
  'lmxmail.sk': true,
  'lobbyist.com': true,
  'localbar.com': true,
  'localgenius.com': true,
  'locos.com': true,
  'login-email.ga': true,
  'loh.pp.ua': true,
  'lol.ovpn.to': true,
  'lolfreak.net': true,
  'lolito.tk': true,
  'lolnetwork.net': true,
  'london.com': true,
  'loobie.com': true,
  'looksmart.co.uk': true,
  'looksmart.com': true,
  'looksmart.com.au': true,
  'lookugly.com': true,
  'lopezclub.com': true,
  'lortemail.dk': true,
  'louiskoo.com': true,
  'lov.ru': true,
  'love.com': true,
  'love.cz': true,
  'loveable.com': true,
  'lovecat.com': true,
  'lovefall.ml': true,
  'lovefootball.com': true,
  'loveforlostcats.com': true,
  'lovelygirl.net': true,
  'lovemail.com': true,
  'lover-boy.com': true,
  'lovergirl.com': true,
  'lovesea.gq': true,
  'lovethebroncos.com': true,
  'lovethecowboys.com': true,
  'lovetocook.net': true,
  'lovetohike.com': true,
  'loveyouforever.de': true,
  'lovingjesus.com': true,
  'lowandslow.com': true,
  'lr7.us': true,
  'lr78.com': true,
  'lroid.com': true,
  'lubovnik.ru': true,
  'lukop.dk': true,
  'luso.pt': true,
  'luukku.com': true,
  'luv2.us': true,
  'luvrhino.com': true,
  'lvie.com.sg': true,
  'lvwebmail.com': true,
  'lycos.co.uk': true,
  'lycos.com': true,
  'lycos.es': true,
  'lycos.it': true,
  'lycos.ne.jp': true,
  'lycos.ru': true,
  'lycosemail.com': true,
  'lycosmail.com': true,
  'm-a-i-l.com': true,
  'm-hmail.com': true,
  'm21.cc': true,
  'm4.org': true,
  'm4ilweb.info': true,
  'mac.com': true,
  'macbox.com': true,
  'macbox.ru': true,
  'macfreak.com': true,
  'machinecandy.com': true,
  'macmail.com': true,
  'mad.scientist.com': true,
  'madcrazy.com': true,
  'madcreations.com': true,
  'madonnafan.com': true,
  'madrid.com': true,
  'maennerversteherin.com': true,
  'maennerversteherin.de': true,
  'maffia.hu': true,
  'magicmail.co.za': true,
  'mahmoodweb.com': true,
  'mail-awu.de': true,
  'mail-box.cz': true,
  'mail-center.com': true,
  'mail-central.com': true,
  'mail-easy.fr': true,
  'mail-filter.com': true,
  'mail-me.com': true,
  'mail-page.com': true,
  'mail-temporaire.fr': true,
  'mail-tester.com': true,
  'mail.austria.com': true,
  'mail.az': true,
  'mail.be': true,
  'mail.bg': true,
  'mail.bulgaria.com': true,
  'mail.by': true,
  'mail.byte.it': true,
  'mail.co.za': true,
  'mail.com': true,
  'mail.com.tr': true,
  'mail.ee': true,
  'mail.entrepeneurmag.com': true,
  'mail.freetown.com': true,
  'mail.gr': true,
  'mail.hitthebeach.com': true,
  'mail.htl22.at': true,
  'mail.kmsp.com': true,
  'mail.md': true,
  'mail.mezimages.net': true,
  'mail.misterpinball.de': true,
  'mail.nu': true,
  'mail.org.uk': true,
  'mail.pf': true,
  'mail.pharmacy.com': true,
  'mail.pt': true,
  'mail.r-o-o-t.com': true,
  'mail.ru': true,
  'mail.salu.net': true,
  'mail.sisna.com': true,
  'mail.spaceports.com': true,
  'mail.svenz.eu': true,
  'mail.theboys.com': true,
  'mail.usa.com': true,
  'mail.vasarhely.hu': true,
  'mail.vu': true,
  'mail.wtf': true,
  'mail.zp.ua': true,
  'mail114.net': true,
  'mail15.com': true,
  'mail1a.de': true,
  'mail1st.com': true,
  'mail2007.com': true,
  'mail21.cc': true,
  'mail2aaron.com': true,
  'mail2abby.com': true,
  'mail2abc.com': true,
  'mail2actor.com': true,
  'mail2admiral.com': true,
  'mail2adorable.com': true,
  'mail2adoration.com': true,
  'mail2adore.com': true,
  'mail2adventure.com': true,
  'mail2aeolus.com': true,
  'mail2aether.com': true,
  'mail2affection.com': true,
  'mail2afghanistan.com': true,
  'mail2africa.com': true,
  'mail2agent.com': true,
  'mail2aha.com': true,
  'mail2ahoy.com': true,
  'mail2aim.com': true,
  'mail2air.com': true,
  'mail2airbag.com': true,
  'mail2airforce.com': true,
  'mail2airport.com': true,
  'mail2alabama.com': true,
  'mail2alan.com': true,
  'mail2alaska.com': true,
  'mail2albania.com': true,
  'mail2alcoholic.com': true,
  'mail2alec.com': true,
  'mail2alexa.com': true,
  'mail2algeria.com': true,
  'mail2alicia.com': true,
  'mail2alien.com': true,
  'mail2allan.com': true,
  'mail2allen.com': true,
  'mail2allison.com': true,
  'mail2alpha.com': true,
  'mail2alyssa.com': true,
  'mail2amanda.com': true,
  'mail2amazing.com': true,
  'mail2amber.com': true,
  'mail2america.com': true,
  'mail2american.com': true,
  'mail2andorra.com': true,
  'mail2andrea.com': true,
  'mail2andy.com': true,
  'mail2anesthesiologist.com': true,
  'mail2angela.com': true,
  'mail2angola.com': true,
  'mail2ann.com': true,
  'mail2anna.com': true,
  'mail2anne.com': true,
  'mail2anthony.com': true,
  'mail2anything.com': true,
  'mail2aphrodite.com': true,
  'mail2apollo.com': true,
  'mail2april.com': true,
  'mail2aquarius.com': true,
  'mail2arabia.com': true,
  'mail2arabic.com': true,
  'mail2architect.com': true,
  'mail2ares.com': true,
  'mail2argentina.com': true,
  'mail2aries.com': true,
  'mail2arizona.com': true,
  'mail2arkansas.com': true,
  'mail2armenia.com': true,
  'mail2army.com': true,
  'mail2arnold.com': true,
  'mail2art.com': true,
  'mail2artemus.com': true,
  'mail2arthur.com': true,
  'mail2artist.com': true,
  'mail2ashley.com': true,
  'mail2ask.com': true,
  'mail2astronomer.com': true,
  'mail2athena.com': true,
  'mail2athlete.com': true,
  'mail2atlas.com': true,
  'mail2atom.com': true,
  'mail2attitude.com': true,
  'mail2auction.com': true,
  'mail2aunt.com': true,
  'mail2australia.com': true,
  'mail2austria.com': true,
  'mail2azerbaijan.com': true,
  'mail2baby.com': true,
  'mail2bahamas.com': true,
  'mail2bahrain.com': true,
  'mail2ballerina.com': true,
  'mail2ballplayer.com': true,
  'mail2band.com': true,
  'mail2bangladesh.com': true,
  'mail2bank.com': true,
  'mail2banker.com': true,
  'mail2bankrupt.com': true,
  'mail2baptist.com': true,
  'mail2bar.com': true,
  'mail2barbados.com': true,
  'mail2barbara.com': true,
  'mail2barter.com': true,
  'mail2basketball.com': true,
  'mail2batter.com': true,
  'mail2beach.com': true,
  'mail2beast.com': true,
  'mail2beatles.com': true,
  'mail2beauty.com': true,
  'mail2becky.com': true,
  'mail2beijing.com': true,
  'mail2belgium.com': true,
  'mail2belize.com': true,
  'mail2ben.com': true,
  'mail2bernard.com': true,
  'mail2beth.com': true,
  'mail2betty.com': true,
  'mail2beverly.com': true,
  'mail2beyond.com': true,
  'mail2biker.com': true,
  'mail2bill.com': true,
  'mail2billionaire.com': true,
  'mail2billy.com': true,
  'mail2bio.com': true,
  'mail2biologist.com': true,
  'mail2black.com': true,
  'mail2blackbelt.com': true,
  'mail2blake.com': true,
  'mail2blind.com': true,
  'mail2blonde.com': true,
  'mail2blues.com': true,
  'mail2bob.com': true,
  'mail2bobby.com': true,
  'mail2bolivia.com': true,
  'mail2bombay.com': true,
  'mail2bonn.com': true,
  'mail2bookmark.com': true,
  'mail2boreas.com': true,
  'mail2bosnia.com': true,
  'mail2boston.com': true,
  'mail2botswana.com': true,
  'mail2bradley.com': true,
  'mail2brazil.com': true,
  'mail2breakfast.com': true,
  'mail2brian.com': true,
  'mail2bride.com': true,
  'mail2brittany.com': true,
  'mail2broker.com': true,
  'mail2brook.com': true,
  'mail2bruce.com': true,
  'mail2brunei.com': true,
  'mail2brunette.com': true,
  'mail2brussels.com': true,
  'mail2bryan.com': true,
  'mail2bug.com': true,
  'mail2bulgaria.com': true,
  'mail2business.com': true,
  'mail2buy.com': true,
  'mail2ca.com': true,
  'mail2california.com': true,
  'mail2calvin.com': true,
  'mail2cambodia.com': true,
  'mail2cameroon.com': true,
  'mail2canada.com': true,
  'mail2cancer.com': true,
  'mail2capeverde.com': true,
  'mail2capricorn.com': true,
  'mail2cardinal.com': true,
  'mail2cardiologist.com': true,
  'mail2care.com': true,
  'mail2caroline.com': true,
  'mail2carolyn.com': true,
  'mail2casey.com': true,
  'mail2cat.com': true,
  'mail2caterer.com': true,
  'mail2cathy.com': true,
  'mail2catlover.com': true,
  'mail2catwalk.com': true,
  'mail2cell.com': true,
  'mail2chad.com': true,
  'mail2champaign.com': true,
  'mail2charles.com': true,
  'mail2chef.com': true,
  'mail2chemist.com': true,
  'mail2cherry.com': true,
  'mail2chicago.com': true,
  'mail2chile.com': true,
  'mail2china.com': true,
  'mail2chinese.com': true,
  'mail2chocolate.com': true,
  'mail2christian.com': true,
  'mail2christie.com': true,
  'mail2christmas.com': true,
  'mail2christy.com': true,
  'mail2chuck.com': true,
  'mail2cindy.com': true,
  'mail2clark.com': true,
  'mail2classifieds.com': true,
  'mail2claude.com': true,
  'mail2cliff.com': true,
  'mail2clinic.com': true,
  'mail2clint.com': true,
  'mail2close.com': true,
  'mail2club.com': true,
  'mail2coach.com': true,
  'mail2coastguard.com': true,
  'mail2colin.com': true,
  'mail2college.com': true,
  'mail2colombia.com': true,
  'mail2color.com': true,
  'mail2colorado.com': true,
  'mail2columbia.com': true,
  'mail2comedian.com': true,
  'mail2composer.com': true,
  'mail2computer.com': true,
  'mail2computers.com': true,
  'mail2concert.com': true,
  'mail2congo.com': true,
  'mail2connect.com': true,
  'mail2connecticut.com': true,
  'mail2consultant.com': true,
  'mail2convict.com': true,
  'mail2cook.com': true,
  'mail2cool.com': true,
  'mail2cory.com': true,
  'mail2costarica.com': true,
  'mail2country.com': true,
  'mail2courtney.com': true,
  'mail2cowboy.com': true,
  'mail2cowgirl.com': true,
  'mail2craig.com': true,
  'mail2crave.com': true,
  'mail2crazy.com': true,
  'mail2create.com': true,
  'mail2croatia.com': true,
  'mail2cry.com': true,
  'mail2crystal.com': true,
  'mail2cuba.com': true,
  'mail2culture.com': true,
  'mail2curt.com': true,
  'mail2customs.com': true,
  'mail2cute.com': true,
  'mail2cutey.com': true,
  'mail2cynthia.com': true,
  'mail2cyprus.com': true,
  'mail2czechrepublic.com': true,
  'mail2dad.com': true,
  'mail2dale.com': true,
  'mail2dallas.com': true,
  'mail2dan.com': true,
  'mail2dana.com': true,
  'mail2dance.com': true,
  'mail2dancer.com': true,
  'mail2danielle.com': true,
  'mail2danny.com': true,
  'mail2darlene.com': true,
  'mail2darling.com': true,
  'mail2darren.com': true,
  'mail2daughter.com': true,
  'mail2dave.com': true,
  'mail2dawn.com': true,
  'mail2dc.com': true,
  'mail2dealer.com': true,
  'mail2deanna.com': true,
  'mail2dearest.com': true,
  'mail2debbie.com': true,
  'mail2debby.com': true,
  'mail2deer.com': true,
  'mail2delaware.com': true,
  'mail2delicious.com': true,
  'mail2demeter.com': true,
  'mail2democrat.com': true,
  'mail2denise.com': true,
  'mail2denmark.com': true,
  'mail2dennis.com': true,
  'mail2dentist.com': true,
  'mail2derek.com': true,
  'mail2desert.com': true,
  'mail2devoted.com': true,
  'mail2devotion.com': true,
  'mail2diamond.com': true,
  'mail2diana.com': true,
  'mail2diane.com': true,
  'mail2diehard.com': true,
  'mail2dilemma.com': true,
  'mail2dillon.com': true,
  'mail2dinner.com': true,
  'mail2dinosaur.com': true,
  'mail2dionysos.com': true,
  'mail2diplomat.com': true,
  'mail2director.com': true,
  'mail2dirk.com': true,
  'mail2disco.com': true,
  'mail2dive.com': true,
  'mail2diver.com': true,
  'mail2divorced.com': true,
  'mail2djibouti.com': true,
  'mail2doctor.com': true,
  'mail2doglover.com': true,
  'mail2dominic.com': true,
  'mail2dominica.com': true,
  'mail2dominicanrepublic.com': true,
  'mail2don.com': true,
  'mail2donald.com': true,
  'mail2donna.com': true,
  'mail2doris.com': true,
  'mail2dorothy.com': true,
  'mail2doug.com': true,
  'mail2dough.com': true,
  'mail2douglas.com': true,
  'mail2dow.com': true,
  'mail2downtown.com': true,
  'mail2dream.com': true,
  'mail2dreamer.com': true,
  'mail2dude.com': true,
  'mail2dustin.com': true,
  'mail2dyke.com': true,
  'mail2dylan.com': true,
  'mail2earl.com': true,
  'mail2earth.com': true,
  'mail2eastend.com': true,
  'mail2eat.com': true,
  'mail2economist.com': true,
  'mail2ecuador.com': true,
  'mail2eddie.com': true,
  'mail2edgar.com': true,
  'mail2edwin.com': true,
  'mail2egypt.com': true,
  'mail2electron.com': true,
  'mail2eli.com': true,
  'mail2elizabeth.com': true,
  'mail2ellen.com': true,
  'mail2elliot.com': true,
  'mail2elsalvador.com': true,
  'mail2elvis.com': true,
  'mail2emergency.com': true,
  'mail2emily.com': true,
  'mail2engineer.com': true,
  'mail2english.com': true,
  'mail2environmentalist.com': true,
  'mail2eos.com': true,
  'mail2eric.com': true,
  'mail2erica.com': true,
  'mail2erin.com': true,
  'mail2erinyes.com': true,
  'mail2eris.com': true,
  'mail2eritrea.com': true,
  'mail2ernie.com': true,
  'mail2eros.com': true,
  'mail2estonia.com': true,
  'mail2ethan.com': true,
  'mail2ethiopia.com': true,
  'mail2eu.com': true,
  'mail2europe.com': true,
  'mail2eurus.com': true,
  'mail2eva.com': true,
  'mail2evan.com': true,
  'mail2evelyn.com': true,
  'mail2everything.com': true,
  'mail2exciting.com': true,
  'mail2expert.com': true,
  'mail2fairy.com': true,
  'mail2faith.com': true,
  'mail2fanatic.com': true,
  'mail2fancy.com': true,
  'mail2fantasy.com': true,
  'mail2farm.com': true,
  'mail2farmer.com': true,
  'mail2fashion.com': true,
  'mail2fat.com': true,
  'mail2feeling.com': true,
  'mail2female.com': true,
  'mail2fever.com': true,
  'mail2fighter.com': true,
  'mail2fiji.com': true,
  'mail2filmfestival.com': true,
  'mail2films.com': true,
  'mail2finance.com': true,
  'mail2finland.com': true,
  'mail2fireman.com': true,
  'mail2firm.com': true,
  'mail2fisherman.com': true,
  'mail2flexible.com': true,
  'mail2florence.com': true,
  'mail2florida.com': true,
  'mail2floyd.com': true,
  'mail2fly.com': true,
  'mail2fond.com': true,
  'mail2fondness.com': true,
  'mail2football.com': true,
  'mail2footballfan.com': true,
  'mail2found.com': true,
  'mail2france.com': true,
  'mail2frank.com': true,
  'mail2frankfurt.com': true,
  'mail2franklin.com': true,
  'mail2fred.com': true,
  'mail2freddie.com': true,
  'mail2free.com': true,
  'mail2freedom.com': true,
  'mail2french.com': true,
  'mail2freudian.com': true,
  'mail2friendship.com': true,
  'mail2from.com': true,
  'mail2fun.com': true,
  'mail2gabon.com': true,
  'mail2gabriel.com': true,
  'mail2gail.com': true,
  'mail2galaxy.com': true,
  'mail2gambia.com': true,
  'mail2games.com': true,
  'mail2gary.com': true,
  'mail2gavin.com': true,
  'mail2gemini.com': true,
  'mail2gene.com': true,
  'mail2genes.com': true,
  'mail2geneva.com': true,
  'mail2george.com': true,
  'mail2georgia.com': true,
  'mail2gerald.com': true,
  'mail2german.com': true,
  'mail2germany.com': true,
  'mail2ghana.com': true,
  'mail2gilbert.com': true,
  'mail2gina.com': true,
  'mail2girl.com': true,
  'mail2glen.com': true,
  'mail2gloria.com': true,
  'mail2goddess.com': true,
  'mail2gold.com': true,
  'mail2golfclub.com': true,
  'mail2golfer.com': true,
  'mail2gordon.com': true,
  'mail2government.com': true,
  'mail2grab.com': true,
  'mail2grace.com': true,
  'mail2graham.com': true,
  'mail2grandma.com': true,
  'mail2grandpa.com': true,
  'mail2grant.com': true,
  'mail2greece.com': true,
  'mail2green.com': true,
  'mail2greg.com': true,
  'mail2grenada.com': true,
  'mail2gsm.com': true,
  'mail2guard.com': true,
  'mail2guatemala.com': true,
  'mail2guy.com': true,
  'mail2hades.com': true,
  'mail2haiti.com': true,
  'mail2hal.com': true,
  'mail2handhelds.com': true,
  'mail2hank.com': true,
  'mail2hannah.com': true,
  'mail2harold.com': true,
  'mail2harry.com': true,
  'mail2hawaii.com': true,
  'mail2headhunter.com': true,
  'mail2heal.com': true,
  'mail2heather.com': true,
  'mail2heaven.com': true,
  'mail2hebe.com': true,
  'mail2hecate.com': true,
  'mail2heidi.com': true,
  'mail2helen.com': true,
  'mail2hell.com': true,
  'mail2help.com': true,
  'mail2helpdesk.com': true,
  'mail2henry.com': true,
  'mail2hephaestus.com': true,
  'mail2hera.com': true,
  'mail2hercules.com': true,
  'mail2herman.com': true,
  'mail2hermes.com': true,
  'mail2hespera.com': true,
  'mail2hestia.com': true,
  'mail2highschool.com': true,
  'mail2hindu.com': true,
  'mail2hip.com': true,
  'mail2hiphop.com': true,
  'mail2holland.com': true,
  'mail2holly.com': true,
  'mail2hollywood.com': true,
  'mail2homer.com': true,
  'mail2honduras.com': true,
  'mail2honey.com': true,
  'mail2hongkong.com': true,
  'mail2hope.com': true,
  'mail2horse.com': true,
  'mail2hot.com': true,
  'mail2hotel.com': true,
  'mail2houston.com': true,
  'mail2howard.com': true,
  'mail2hugh.com': true,
  'mail2human.com': true,
  'mail2hungary.com': true,
  'mail2hungry.com': true,
  'mail2hygeia.com': true,
  'mail2hyperspace.com': true,
  'mail2hypnos.com': true,
  'mail2ian.com': true,
  'mail2ice-cream.com': true,
  'mail2iceland.com': true,
  'mail2idaho.com': true,
  'mail2idontknow.com': true,
  'mail2illinois.com': true,
  'mail2imam.com': true,
  'mail2in.com': true,
  'mail2india.com': true,
  'mail2indian.com': true,
  'mail2indiana.com': true,
  'mail2indonesia.com': true,
  'mail2infinity.com': true,
  'mail2intense.com': true,
  'mail2iowa.com': true,
  'mail2iran.com': true,
  'mail2iraq.com': true,
  'mail2ireland.com': true,
  'mail2irene.com': true,
  'mail2iris.com': true,
  'mail2irresistible.com': true,
  'mail2irving.com': true,
  'mail2irwin.com': true,
  'mail2isaac.com': true,
  'mail2israel.com': true,
  'mail2italian.com': true,
  'mail2italy.com': true,
  'mail2jackie.com': true,
  'mail2jacob.com': true,
  'mail2jail.com': true,
  'mail2jaime.com': true,
  'mail2jake.com': true,
  'mail2jamaica.com': true,
  'mail2james.com': true,
  'mail2jamie.com': true,
  'mail2jan.com': true,
  'mail2jane.com': true,
  'mail2janet.com': true,
  'mail2janice.com': true,
  'mail2japan.com': true,
  'mail2japanese.com': true,
  'mail2jasmine.com': true,
  'mail2jason.com': true,
  'mail2java.com': true,
  'mail2jay.com': true,
  'mail2jazz.com': true,
  'mail2jed.com': true,
  'mail2jeffrey.com': true,
  'mail2jennifer.com': true,
  'mail2jenny.com': true,
  'mail2jeremy.com': true,
  'mail2jerry.com': true,
  'mail2jessica.com': true,
  'mail2jessie.com': true,
  'mail2jesus.com': true,
  'mail2jew.com': true,
  'mail2jeweler.com': true,
  'mail2jim.com': true,
  'mail2jimmy.com': true,
  'mail2joan.com': true,
  'mail2joann.com': true,
  'mail2joanna.com': true,
  'mail2jody.com': true,
  'mail2joe.com': true,
  'mail2joel.com': true,
  'mail2joey.com': true,
  'mail2john.com': true,
  'mail2join.com': true,
  'mail2jon.com': true,
  'mail2jonathan.com': true,
  'mail2jones.com': true,
  'mail2jordan.com': true,
  'mail2joseph.com': true,
  'mail2josh.com': true,
  'mail2joy.com': true,
  'mail2juan.com': true,
  'mail2judge.com': true,
  'mail2judy.com': true,
  'mail2juggler.com': true,
  'mail2julian.com': true,
  'mail2julie.com': true,
  'mail2jumbo.com': true,
  'mail2junk.com': true,
  'mail2justin.com': true,
  'mail2justme.com': true,
  'mail2k.ru': true,
  'mail2kansas.com': true,
  'mail2karate.com': true,
  'mail2karen.com': true,
  'mail2karl.com': true,
  'mail2karma.com': true,
  'mail2kathleen.com': true,
  'mail2kathy.com': true,
  'mail2katie.com': true,
  'mail2kay.com': true,
  'mail2kazakhstan.com': true,
  'mail2keen.com': true,
  'mail2keith.com': true,
  'mail2kelly.com': true,
  'mail2kelsey.com': true,
  'mail2ken.com': true,
  'mail2kendall.com': true,
  'mail2kennedy.com': true,
  'mail2kenneth.com': true,
  'mail2kenny.com': true,
  'mail2kentucky.com': true,
  'mail2kenya.com': true,
  'mail2kerry.com': true,
  'mail2kevin.com': true,
  'mail2kim.com': true,
  'mail2kimberly.com': true,
  'mail2king.com': true,
  'mail2kirk.com': true,
  'mail2kiss.com': true,
  'mail2kosher.com': true,
  'mail2kristin.com': true,
  'mail2kurt.com': true,
  'mail2kuwait.com': true,
  'mail2kyle.com': true,
  'mail2kyrgyzstan.com': true,
  'mail2la.com': true,
  'mail2lacrosse.com': true,
  'mail2lance.com': true,
  'mail2lao.com': true,
  'mail2larry.com': true,
  'mail2latvia.com': true,
  'mail2laugh.com': true,
  'mail2laura.com': true,
  'mail2lauren.com': true,
  'mail2laurie.com': true,
  'mail2lawrence.com': true,
  'mail2lawyer.com': true,
  'mail2lebanon.com': true,
  'mail2lee.com': true,
  'mail2leo.com': true,
  'mail2leon.com': true,
  'mail2leonard.com': true,
  'mail2leone.com': true,
  'mail2leslie.com': true,
  'mail2letter.com': true,
  'mail2liberia.com': true,
  'mail2libertarian.com': true,
  'mail2libra.com': true,
  'mail2libya.com': true,
  'mail2liechtenstein.com': true,
  'mail2life.com': true,
  'mail2linda.com': true,
  'mail2linux.com': true,
  'mail2lionel.com': true,
  'mail2lipstick.com': true,
  'mail2liquid.com': true,
  'mail2lisa.com': true,
  'mail2lithuania.com': true,
  'mail2litigator.com': true,
  'mail2liz.com': true,
  'mail2lloyd.com': true,
  'mail2lois.com': true,
  'mail2lola.com': true,
  'mail2london.com': true,
  'mail2looking.com': true,
  'mail2lori.com': true,
  'mail2lost.com': true,
  'mail2lou.com': true,
  'mail2louis.com': true,
  'mail2louisiana.com': true,
  'mail2lovable.com': true,
  'mail2love.com': true,
  'mail2lucky.com': true,
  'mail2lucy.com': true,
  'mail2lunch.com': true,
  'mail2lust.com': true,
  'mail2luxembourg.com': true,
  'mail2luxury.com': true,
  'mail2lyle.com': true,
  'mail2lynn.com': true,
  'mail2madagascar.com': true,
  'mail2madison.com': true,
  'mail2madrid.com': true,
  'mail2maggie.com': true,
  'mail2mail4.com': true,
  'mail2maine.com': true,
  'mail2malawi.com': true,
  'mail2malaysia.com': true,
  'mail2maldives.com': true,
  'mail2mali.com': true,
  'mail2malta.com': true,
  'mail2mambo.com': true,
  'mail2man.com': true,
  'mail2mandy.com': true,
  'mail2manhunter.com': true,
  'mail2mankind.com': true,
  'mail2many.com': true,
  'mail2marc.com': true,
  'mail2marcia.com': true,
  'mail2margaret.com': true,
  'mail2margie.com': true,
  'mail2marhaba.com': true,
  'mail2maria.com': true,
  'mail2marilyn.com': true,
  'mail2marines.com': true,
  'mail2mark.com': true,
  'mail2marriage.com': true,
  'mail2married.com': true,
  'mail2marries.com': true,
  'mail2mars.com': true,
  'mail2marsha.com': true,
  'mail2marshallislands.com': true,
  'mail2martha.com': true,
  'mail2martin.com': true,
  'mail2marty.com': true,
  'mail2marvin.com': true,
  'mail2mary.com': true,
  'mail2maryland.com': true,
  'mail2mason.com': true,
  'mail2massachusetts.com': true,
  'mail2matt.com': true,
  'mail2matthew.com': true,
  'mail2maurice.com': true,
  'mail2mauritania.com': true,
  'mail2mauritius.com': true,
  'mail2max.com': true,
  'mail2maxwell.com': true,
  'mail2maybe.com': true,
  'mail2mba.com': true,
  'mail2me4u.com': true,
  'mail2mechanic.com': true,
  'mail2medieval.com': true,
  'mail2megan.com': true,
  'mail2mel.com': true,
  'mail2melanie.com': true,
  'mail2melissa.com': true,
  'mail2melody.com': true,
  'mail2member.com': true,
  'mail2memphis.com': true,
  'mail2methodist.com': true,
  'mail2mexican.com': true,
  'mail2mexico.com': true,
  'mail2mgz.com': true,
  'mail2miami.com': true,
  'mail2michael.com': true,
  'mail2michelle.com': true,
  'mail2michigan.com': true,
  'mail2mike.com': true,
  'mail2milan.com': true,
  'mail2milano.com': true,
  'mail2mildred.com': true,
  'mail2milkyway.com': true,
  'mail2millennium.com': true,
  'mail2millionaire.com': true,
  'mail2milton.com': true,
  'mail2mime.com': true,
  'mail2mindreader.com': true,
  'mail2mini.com': true,
  'mail2minister.com': true,
  'mail2minneapolis.com': true,
  'mail2minnesota.com': true,
  'mail2miracle.com': true,
  'mail2missionary.com': true,
  'mail2mississippi.com': true,
  'mail2missouri.com': true,
  'mail2mitch.com': true,
  'mail2model.com': true,
  'mail2moldova.commail2molly.com': true,
  'mail2mom.com': true,
  'mail2monaco.com': true,
  'mail2money.com': true,
  'mail2mongolia.com': true,
  'mail2monica.com': true,
  'mail2montana.com': true,
  'mail2monty.com': true,
  'mail2moon.com': true,
  'mail2morocco.com': true,
  'mail2morpheus.com': true,
  'mail2mors.com': true,
  'mail2moscow.com': true,
  'mail2moslem.com': true,
  'mail2mouseketeer.com': true,
  'mail2movies.com': true,
  'mail2mozambique.com': true,
  'mail2mp3.com': true,
  'mail2mrright.com': true,
  'mail2msright.com': true,
  'mail2museum.com': true,
  'mail2music.com': true,
  'mail2musician.com': true,
  'mail2muslim.com': true,
  'mail2my.com': true,
  'mail2myboat.com': true,
  'mail2mycar.com': true,
  'mail2mycell.com': true,
  'mail2mygsm.com': true,
  'mail2mylaptop.com': true,
  'mail2mymac.com': true,
  'mail2mypager.com': true,
  'mail2mypalm.com': true,
  'mail2mypc.com': true,
  'mail2myphone.com': true,
  'mail2myplane.com': true,
  'mail2namibia.com': true,
  'mail2nancy.com': true,
  'mail2nasdaq.com': true,
  'mail2nathan.com': true,
  'mail2nauru.com': true,
  'mail2navy.com': true,
  'mail2neal.com': true,
  'mail2nebraska.com': true,
  'mail2ned.com': true,
  'mail2neil.com': true,
  'mail2nelson.com': true,
  'mail2nemesis.com': true,
  'mail2nepal.com': true,
  'mail2netherlands.com': true,
  'mail2network.com': true,
  'mail2nevada.com': true,
  'mail2newhampshire.com': true,
  'mail2newjersey.com': true,
  'mail2newmexico.com': true,
  'mail2newyork.com': true,
  'mail2newzealand.com': true,
  'mail2nicaragua.com': true,
  'mail2nick.com': true,
  'mail2nicole.com': true,
  'mail2niger.com': true,
  'mail2nigeria.com': true,
  'mail2nike.com': true,
  'mail2no.com': true,
  'mail2noah.com': true,
  'mail2noel.com': true,
  'mail2noelle.com': true,
  'mail2normal.com': true,
  'mail2norman.com': true,
  'mail2northamerica.com': true,
  'mail2northcarolina.com': true,
  'mail2northdakota.com': true,
  'mail2northpole.com': true,
  'mail2norway.com': true,
  'mail2notus.com': true,
  'mail2noway.com': true,
  'mail2nowhere.com': true,
  'mail2nuclear.com': true,
  'mail2nun.com': true,
  'mail2ny.com': true,
  'mail2oasis.com': true,
  'mail2oceanographer.com': true,
  'mail2ohio.com': true,
  'mail2ok.com': true,
  'mail2oklahoma.com': true,
  'mail2oliver.com': true,
  'mail2oman.com': true,
  'mail2one.com': true,
  'mail2onfire.com': true,
  'mail2online.com': true,
  'mail2oops.com': true,
  'mail2open.com': true,
  'mail2ophthalmologist.com': true,
  'mail2optometrist.com': true,
  'mail2oregon.com': true,
  'mail2oscars.com': true,
  'mail2oslo.com': true,
  'mail2painter.com': true,
  'mail2pakistan.com': true,
  'mail2palau.com': true,
  'mail2pan.com': true,
  'mail2panama.com': true,
  'mail2paraguay.com': true,
  'mail2paralegal.com': true,
  'mail2paris.com': true,
  'mail2park.com': true,
  'mail2parker.com': true,
  'mail2party.com': true,
  'mail2passion.com': true,
  'mail2pat.com': true,
  'mail2patricia.com': true,
  'mail2patrick.com': true,
  'mail2patty.com': true,
  'mail2paul.com': true,
  'mail2paula.com': true,
  'mail2pay.com': true,
  'mail2peace.com': true,
  'mail2pediatrician.com': true,
  'mail2peggy.com': true,
  'mail2pennsylvania.com': true,
  'mail2perry.com': true,
  'mail2persephone.com': true,
  'mail2persian.com': true,
  'mail2peru.com': true,
  'mail2pete.com': true,
  'mail2peter.com': true,
  'mail2pharmacist.com': true,
  'mail2phil.com': true,
  'mail2philippines.com': true,
  'mail2phoenix.com': true,
  'mail2phonecall.com': true,
  'mail2phyllis.com': true,
  'mail2pickup.com': true,
  'mail2pilot.com': true,
  'mail2pisces.com': true,
  'mail2planet.com': true,
  'mail2platinum.com': true,
  'mail2plato.com': true,
  'mail2pluto.com': true,
  'mail2pm.com': true,
  'mail2podiatrist.com': true,
  'mail2poet.com': true,
  'mail2poland.com': true,
  'mail2policeman.com': true,
  'mail2policewoman.com': true,
  'mail2politician.com': true,
  'mail2pop.com': true,
  'mail2pope.com': true,
  'mail2popular.com': true,
  'mail2portugal.com': true,
  'mail2poseidon.com': true,
  'mail2potatohead.com': true,
  'mail2power.com': true,
  'mail2presbyterian.com': true,
  'mail2president.com': true,
  'mail2priest.com': true,
  'mail2prince.com': true,
  'mail2princess.com': true,
  'mail2producer.com': true,
  'mail2professor.com': true,
  'mail2protect.com': true,
  'mail2psychiatrist.com': true,
  'mail2psycho.com': true,
  'mail2psychologist.com': true,
  'mail2qatar.com': true,
  'mail2queen.com': true,
  'mail2rabbi.com': true,
  'mail2race.com': true,
  'mail2racer.com': true,
  'mail2rachel.com': true,
  'mail2rage.com': true,
  'mail2rainmaker.com': true,
  'mail2ralph.com': true,
  'mail2randy.com': true,
  'mail2rap.com': true,
  'mail2rare.com': true,
  'mail2rave.com': true,
  'mail2ray.com': true,
  'mail2raymond.com': true,
  'mail2realtor.com': true,
  'mail2rebecca.com': true,
  'mail2recruiter.com': true,
  'mail2recycle.com': true,
  'mail2redhead.com': true,
  'mail2reed.com': true,
  'mail2reggie.com': true,
  'mail2register.com': true,
  'mail2rent.com': true,
  'mail2republican.com': true,
  'mail2resort.com': true,
  'mail2rex.com': true,
  'mail2rhodeisland.com': true,
  'mail2rich.com': true,
  'mail2richard.com': true,
  'mail2ricky.com': true,
  'mail2ride.com': true,
  'mail2riley.com': true,
  'mail2rita.com': true,
  'mail2rob.com': true,
  'mail2robert.com': true,
  'mail2roberta.com': true,
  'mail2robin.com': true,
  'mail2rock.com': true,
  'mail2rocker.com': true,
  'mail2rod.com': true,
  'mail2rodney.com': true,
  'mail2romania.com': true,
  'mail2rome.com': true,
  'mail2ron.com': true,
  'mail2ronald.com': true,
  'mail2ronnie.com': true,
  'mail2rose.com': true,
  'mail2rosie.com': true,
  'mail2roy.com': true,
  'mail2rss.org': true,
  'mail2rudy.com': true,
  'mail2rugby.com': true,
  'mail2runner.com': true,
  'mail2russell.com': true,
  'mail2russia.com': true,
  'mail2russian.com': true,
  'mail2rusty.com': true,
  'mail2ruth.com': true,
  'mail2rwanda.com': true,
  'mail2ryan.com': true,
  'mail2sa.com': true,
  'mail2sabrina.com': true,
  'mail2safe.com': true,
  'mail2sagittarius.com': true,
  'mail2sail.com': true,
  'mail2sailor.com': true,
  'mail2sal.com': true,
  'mail2salaam.com': true,
  'mail2sam.com': true,
  'mail2samantha.com': true,
  'mail2samoa.com': true,
  'mail2samurai.com': true,
  'mail2sandra.com': true,
  'mail2sandy.com': true,
  'mail2sanfrancisco.com': true,
  'mail2sanmarino.com': true,
  'mail2santa.com': true,
  'mail2sara.com': true,
  'mail2sarah.com': true,
  'mail2sat.com': true,
  'mail2saturn.com': true,
  'mail2saudi.com': true,
  'mail2saudiarabia.com': true,
  'mail2save.com': true,
  'mail2savings.com': true,
  'mail2school.com': true,
  'mail2scientist.com': true,
  'mail2scorpio.com': true,
  'mail2scott.com': true,
  'mail2sean.com': true,
  'mail2search.com': true,
  'mail2seattle.com': true,
  'mail2secretagent.com': true,
  'mail2senate.com': true,
  'mail2senegal.com': true,
  'mail2sensual.com': true,
  'mail2seth.com': true,
  'mail2sevenseas.com': true,
  'mail2sexy.com': true,
  'mail2seychelles.com': true,
  'mail2shane.com': true,
  'mail2sharon.com': true,
  'mail2shawn.com': true,
  'mail2ship.com': true,
  'mail2shirley.com': true,
  'mail2shoot.com': true,
  'mail2shuttle.com': true,
  'mail2sierraleone.com': true,
  'mail2simon.com': true,
  'mail2singapore.com': true,
  'mail2single.com': true,
  'mail2site.com': true,
  'mail2skater.com': true,
  'mail2skier.com': true,
  'mail2sky.com': true,
  'mail2sleek.com': true,
  'mail2slim.com': true,
  'mail2slovakia.com': true,
  'mail2slovenia.com': true,
  'mail2smile.com': true,
  'mail2smith.com': true,
  'mail2smooth.com': true,
  'mail2soccer.com': true,
  'mail2soccerfan.com': true,
  'mail2socialist.com': true,
  'mail2soldier.com': true,
  'mail2somalia.com': true,
  'mail2son.com': true,
  'mail2song.com': true,
  'mail2sos.com': true,
  'mail2sound.com': true,
  'mail2southafrica.com': true,
  'mail2southamerica.com': true,
  'mail2southcarolina.com': true,
  'mail2southdakota.com': true,
  'mail2southkorea.com': true,
  'mail2southpole.com': true,
  'mail2spain.com': true,
  'mail2spanish.com': true,
  'mail2spare.com': true,
  'mail2spectrum.com': true,
  'mail2splash.com': true,
  'mail2sponsor.com': true,
  'mail2sports.com': true,
  'mail2srilanka.com': true,
  'mail2stacy.com': true,
  'mail2stan.com': true,
  'mail2stanley.com': true,
  'mail2star.com': true,
  'mail2state.com': true,
  'mail2stephanie.com': true,
  'mail2steve.com': true,
  'mail2steven.com': true,
  'mail2stewart.com': true,
  'mail2stlouis.com': true,
  'mail2stock.com': true,
  'mail2stockholm.com': true,
  'mail2stockmarket.com': true,
  'mail2storage.com': true,
  'mail2store.com': true,
  'mail2strong.com': true,
  'mail2student.com': true,
  'mail2studio.com': true,
  'mail2studio54.com': true,
  'mail2stuntman.com': true,
  'mail2subscribe.com': true,
  'mail2sudan.com': true,
  'mail2superstar.com': true,
  'mail2surfer.com': true,
  'mail2suriname.com': true,
  'mail2susan.com': true,
  'mail2suzie.com': true,
  'mail2swaziland.com': true,
  'mail2sweden.com': true,
  'mail2sweetheart.com': true,
  'mail2swim.com': true,
  'mail2swimmer.com': true,
  'mail2swiss.com': true,
  'mail2switzerland.com': true,
  'mail2sydney.com': true,
  'mail2sylvia.com': true,
  'mail2syria.com': true,
  'mail2taboo.com': true,
  'mail2taiwan.com': true,
  'mail2tajikistan.com': true,
  'mail2tammy.com': true,
  'mail2tango.com': true,
  'mail2tanya.com': true,
  'mail2tanzania.com': true,
  'mail2tara.com': true,
  'mail2taurus.com': true,
  'mail2taxi.com': true,
  'mail2taxidermist.com': true,
  'mail2taylor.com': true,
  'mail2taz.com': true,
  'mail2teacher.com': true,
  'mail2technician.com': true,
  'mail2ted.com': true,
  'mail2telephone.com': true,
  'mail2teletubbie.com': true,
  'mail2tenderness.com': true,
  'mail2tennessee.com': true,
  'mail2tennis.com': true,
  'mail2tennisfan.com': true,
  'mail2terri.com': true,
  'mail2terry.com': true,
  'mail2test.com': true,
  'mail2texas.com': true,
  'mail2thailand.com': true,
  'mail2therapy.com': true,
  'mail2think.com': true,
  'mail2tickets.com': true,
  'mail2tiffany.com': true,
  'mail2tim.com': true,
  'mail2time.com': true,
  'mail2timothy.com': true,
  'mail2tina.com': true,
  'mail2titanic.com': true,
  'mail2toby.com': true,
  'mail2todd.com': true,
  'mail2togo.com': true,
  'mail2tom.com': true,
  'mail2tommy.com': true,
  'mail2tonga.com': true,
  'mail2tony.com': true,
  'mail2touch.com': true,
  'mail2tourist.com': true,
  'mail2tracey.com': true,
  'mail2tracy.com': true,
  'mail2tramp.com': true,
  'mail2travel.com': true,
  'mail2traveler.com': true,
  'mail2travis.com': true,
  'mail2trekkie.com': true,
  'mail2trex.com': true,
  'mail2triallawyer.com': true,
  'mail2trick.com': true,
  'mail2trillionaire.com': true,
  'mail2troy.com': true,
  'mail2truck.com': true,
  'mail2trump.com': true,
  'mail2try.com': true,
  'mail2tunisia.com': true,
  'mail2turbo.com': true,
  'mail2turkey.com': true,
  'mail2turkmenistan.com': true,
  'mail2tv.com': true,
  'mail2tycoon.com': true,
  'mail2tyler.com': true,
  'mail2u4me.com': true,
  'mail2uae.com': true,
  'mail2uganda.com': true,
  'mail2uk.com': true,
  'mail2ukraine.com': true,
  'mail2uncle.com': true,
  'mail2unsubscribe.com': true,
  'mail2uptown.com': true,
  'mail2uruguay.com': true,
  'mail2usa.com': true,
  'mail2utah.com': true,
  'mail2uzbekistan.com': true,
  'mail2v.com': true,
  'mail2vacation.com': true,
  'mail2valentines.com': true,
  'mail2valerie.com': true,
  'mail2valley.com': true,
  'mail2vamoose.com': true,
  'mail2vanessa.com': true,
  'mail2vanuatu.com': true,
  'mail2venezuela.com': true,
  'mail2venous.com': true,
  'mail2venus.com': true,
  'mail2vermont.com': true,
  'mail2vickie.com': true,
  'mail2victor.com': true,
  'mail2victoria.com': true,
  'mail2vienna.com': true,
  'mail2vietnam.com': true,
  'mail2vince.com': true,
  'mail2virginia.com': true,
  'mail2virgo.com': true,
  'mail2visionary.com': true,
  'mail2vodka.com': true,
  'mail2volleyball.com': true,
  'mail2waiter.com': true,
  'mail2wallstreet.com': true,
  'mail2wally.com': true,
  'mail2walter.com': true,
  'mail2warren.com': true,
  'mail2washington.com': true,
  'mail2wave.com': true,
  'mail2way.com': true,
  'mail2waycool.com': true,
  'mail2wayne.com': true,
  'mail2webmaster.com': true,
  'mail2webtop.com': true,
  'mail2webtv.com': true,
  'mail2weird.com': true,
  'mail2wendell.com': true,
  'mail2wendy.com': true,
  'mail2westend.com': true,
  'mail2westvirginia.com': true,
  'mail2whether.com': true,
  'mail2whip.com': true,
  'mail2white.com': true,
  'mail2whitehouse.com': true,
  'mail2whitney.com': true,
  'mail2why.com': true,
  'mail2wilbur.com': true,
  'mail2wild.com': true,
  'mail2willard.com': true,
  'mail2willie.com': true,
  'mail2wine.com': true,
  'mail2winner.com': true,
  'mail2wired.com': true,
  'mail2wisconsin.com': true,
  'mail2woman.com': true,
  'mail2wonder.com': true,
  'mail2world.com': true,
  'mail2worship.com': true,
  'mail2wow.com': true,
  'mail2www.com': true,
  'mail2wyoming.com': true,
  'mail2xfiles.com': true,
  'mail2xox.com': true,
  'mail2yachtclub.com': true,
  'mail2yahalla.com': true,
  'mail2yemen.com': true,
  'mail2yes.com': true,
  'mail2yugoslavia.com': true,
  'mail2zack.com': true,
  'mail2zambia.com': true,
  'mail2zenith.com': true,
  'mail2zephir.com': true,
  'mail2zeus.com': true,
  'mail2zipper.com': true,
  'mail2zoo.com': true,
  'mail2zoologist.com': true,
  'mail2zurich.com': true,
  'mail3000.com': true,
  'mail333.com': true,
  'mail4trash.com': true,
  'mail4u.info': true,
  'mail8.com': true,
  'mailandftp.com': true,
  'mailandnews.com': true,
  'mailas.com': true,
  'mailasia.com': true,
  'mailbidon.com': true,
  'mailbiz.biz': true,
  'mailblocks.com': true,
  'mailbolt.com': true,
  'mailbomb.net': true,
  'mailboom.com': true,
  'mailbox.as': true,
  'mailbox.co.za': true,
  'mailbox.gr': true,
  'mailbox.hu': true,
  'mailbox72.biz': true,
  'mailbox80.biz': true,
  'mailbr.com.br': true,
  'mailbucket.org': true,
  'mailc.net': true,
  'mailcan.com': true,
  'mailcat.biz': true,
  'mailcatch.com': true,
  'mailcc.com': true,
  'mailchoose.co': true,
  'mailcity.com': true,
  'mailclub.fr': true,
  'mailclub.net': true,
  'mailde.de': true,
  'mailde.info': true,
  'maildrop.cc': true,
  'maildrop.gq': true,
  'maildx.com': true,
  'mailed.ro': true,
  'maileimer.de': true,
  'mailexcite.com': true,
  'mailexpire.com': true,
  'mailfa.tk': true,
  'mailfly.com': true,
  'mailforce.net': true,
  'mailforspam.com': true,
  'mailfree.gq': true,
  'mailfreeonline.com': true,
  'mailfreeway.com': true,
  'mailfs.com': true,
  'mailftp.com': true,
  'mailgate.gr': true,
  'mailgate.ru': true,
  'mailgenie.net': true,
  'mailguard.me': true,
  'mailhaven.com': true,
  'mailhood.com': true,
  'mailimate.com': true,
  'mailin8r.com': true,
  'mailinatar.com': true,
  'mailinater.com': true,
  'mailinator.com': true,
  'mailinator.net': true,
  'mailinator.org': true,
  'mailinator.us': true,
  'mailinator2.com': true,
  'mailinblack.com': true,
  'mailincubator.com': true,
  'mailingaddress.org': true,
  'mailingweb.com': true,
  'mailisent.com': true,
  'mailismagic.com': true,
  'mailite.com': true,
  'mailmate.com': true,
  'mailme.dk': true,
  'mailme.gq': true,
  'mailme.ir': true,
  'mailme.lv': true,
  'mailme24.com': true,
  'mailmetrash.com': true,
  'mailmight.com': true,
  'mailmij.nl': true,
  'mailmoat.com': true,
  'mailms.com': true,
  'mailnator.com': true,
  'mailnesia.com': true,
  'mailnew.com': true,
  'mailnull.com': true,
  'mailops.com': true,
  'mailorg.org': true,
  'mailoye.com': true,
  'mailpanda.com': true,
  'mailpick.biz': true,
  'mailpokemon.com': true,
  'mailpost.zzn.com': true,
  'mailpride.com': true,
  'mailproxsy.com': true,
  'mailpuppy.com': true,
  'mailquack.com': true,
  'mailrock.biz': true,
  'mailroom.com': true,
  'mailru.com': true,
  'mailsac.com': true,
  'mailscrap.com': true,
  'mailseal.de': true,
  'mailsent.net': true,
  'mailserver.ru': true,
  'mailservice.ms': true,
  'mailshell.com': true,
  'mailshuttle.com': true,
  'mailsiphon.com': true,
  'mailslapping.com': true,
  'mailsnare.net': true,
  'mailstart.com': true,
  'mailstartplus.com': true,
  'mailsurf.com': true,
  'mailtag.com': true,
  'mailtemp.info': true,
  'mailto.de': true,
  'mailtome.de': true,
  'mailtothis.com': true,
  'mailtrash.net': true,
  'mailtv.net': true,
  'mailtv.tv': true,
  'mailueberfall.de': true,
  'mailup.net': true,
  'mailwire.com': true,
  'mailworks.org': true,
  'mailzi.ru': true,
  'mailzilla.com': true,
  'mailzilla.org': true,
  'makemetheking.com': true,
  'maktoob.com': true,
  'malayalamtelevision.net': true,
  'malayalapathram.com': true,
  'male.ru': true,
  'maltesemail.com': true,
  'mamber.net': true,
  'manager.de': true,
  'manager.in.th': true,
  'mancity.net': true,
  'manlymail.net': true,
  'mantrafreenet.com': true,
  'mantramail.com': true,
  'mantraonline.com': true,
  'manutdfans.com': true,
  'manybrain.com': true,
  'marchmail.com': true,
  'marfino.net': true,
  'margarita.ru': true,
  'mariah-carey.ml.org': true,
  'mariahc.com': true,
  'marijuana.com': true,
  'marijuana.nl': true,
  'marketing.lu': true,
  'marketingfanatic.com': true,
  'marketweighton.com': true,
  'married-not.com': true,
  'marriedandlovingit.com': true,
  'marry.ru': true,
  'marsattack.com': true,
  'martindalemail.com': true,
  'martinguerre.net': true,
  'mash4077.com': true,
  'masrawy.com': true,
  'matmail.com': true,
  'mauimail.com': true,
  'mauritius.com': true,
  'maximumedge.com': true,
  'maxleft.com': true,
  'maxmail.co.uk': true,
  'mayaple.ru': true,
  'mbox.com.au': true,
  'mbx.cc': true,
  'mchsi.com': true,
  'mcrmail.com': true,
  'me-mail.hu': true,
  'me.com': true,
  'meanpeoplesuck.com': true,
  'meatismurder.net': true,
  'medical.net.au': true,
  'medmail.com': true,
  'medscape.com': true,
  'meetingmall.com': true,
  'mega.zik.dj': true,
  'megago.com': true,
  'megamail.pt': true,
  'megapoint.com': true,
  'mehrani.com': true,
  'mehtaweb.com': true,
  'meine-dateien.info': true,
  'meine-diashow.de': true,
  'meine-fotos.info': true,
  'meine-urlaubsfotos.de': true,
  'meinspamschutz.de': true,
  'mekhong.com': true,
  'melodymail.com': true,
  'meloo.com': true,
  'meltmail.com': true,
  'members.student.com': true,
  'menja.net': true,
  'merda.flu.cc': true,
  'merda.igg.biz': true,
  'merda.nut.cc': true,
  'merda.usa.cc': true,
  'merseymail.com': true,
  'mesra.net': true,
  'message.hu': true,
  'message.myspace.com': true,
  'messagebeamer.de': true,
  'messages.to': true,
  'messagez.com': true,
  'metacrawler.com': true,
  'metalfan.com': true,
  'metaping.com': true,
  'metta.lk': true,
  'mexicomail.com': true,
  'mezimages.net': true,
  'mfsa.ru': true,
  'miatadriver.com': true,
  'mierdamail.com': true,
  'miesto.sk': true,
  'mighty.co.za': true,
  'migmail.net': true,
  'migmail.pl': true,
  'migumail.com': true,
  'miho-nakayama.com': true,
  'mikrotamanet.com': true,
  'millionaireintraining.com': true,
  'millionairemail.com': true,
  'milmail.com': true,
  'milmail.com15': true,
  'mindless.com': true,
  'mindspring.com': true,
  'minermail.com': true,
  'mini-mail.com': true,
  'minister.com': true,
  'ministry-of-silly-walks.de': true,
  'mintemail.com': true,
  'misery.net': true,
  'misterpinball.de': true,
  'mit.tc': true,
  'mittalweb.com': true,
  'mixmail.com': true,
  'mjfrogmail.com': true,
  'ml1.net': true,
  'mlanime.com': true,
  'mlb.bounce.ed10.net': true,
  'mm.st': true,
  'mmail.com': true,
  'mns.ru': true,
  'mo3gov.net': true,
  'moakt.com': true,
  'mobico.ru': true,
  'mobilbatam.com': true,
  'mobileninja.co.uk': true,
  'mochamail.com': true,
  'modemnet.net': true,
  'modernenglish.com': true,
  'modomail.com': true,
  'mohammed.com': true,
  'mohmal.com': true,
  'moldova.cc': true,
  'moldova.com': true,
  'moldovacc.com': true,
  'mom-mail.com': true,
  'momslife.com': true,
  'moncourrier.fr.nf': true,
  'monemail.com': true,
  'monemail.fr.nf': true,
  'money.net': true,
  'mongol.net': true,
  'monmail.fr.nf': true,
  'monsieurcinema.com': true,
  'montevideo.com.uy': true,
  'monumentmail.com': true,
  'moomia.com': true,
  'moonman.com': true,
  'moose-mail.com': true,
  'mor19.uu.gl': true,
  'mortaza.com': true,
  'mosaicfx.com': true,
  'moscowmail.com': true,
  'mosk.ru': true,
  'most-wanted.com': true,
  'mostlysunny.com': true,
  'motorcyclefan.net': true,
  'motormania.com': true,
  'movemail.com': true,
  'movieemail.net': true,
  'movieluver.com': true,
  'mox.pp.ua': true,
  'mozartmail.com': true,
  'mozhno.net': true,
  'mp3haze.com': true,
  'mp4.it': true,
  'mr-potatohead.com': true,
  'mrpost.com': true,
  'mrspender.com': true,
  'mscold.com': true,
  'msgbox.com': true,
  'msn.cn': true,
  'msn.com': true,
  'msn.nl': true,
  'msx.ru': true,
  'mt2009.com': true,
  'mt2014.com': true,
  'mt2015.com': true,
  'mt2016.com': true,
  'mttestdriver.com': true,
  'muehlacker.tk': true,
  multiplechoices: true,
  'mundomail.net': true,
  'munich.com': true,
  'music.com': true,
  'music.com19': true,
  'music.maigate.ru': true,
  'musician.com': true,
  'musician.org': true,
  'musicscene.org': true,
  'muskelshirt.de': true,
  'muslim.com': true,
  'muslimemail.com': true,
  'muslimsonline.com': true,
  'mutantweb.com': true,
  'mvrht.com': true,
  'my.com': true,
  'my10minutemail.com': true,
  'mybox.it': true,
  'mycabin.com': true,
  'mycampus.com': true,
  'mycard.net.ua': true,
  'mycity.com': true,
  'mycleaninbox.net': true,
  'mycool.com': true,
  'mydomain.com': true,
  'mydotcomaddress.com': true,
  'myfairpoint.net': true,
  'myfamily.com': true,
  'myfastmail.com': true,
  'myfunnymail.com': true,
  'mygo.com': true,
  'myiris.com': true,
  'myjazzmail.com': true,
  'mymac.ru': true,
  'mymacmail.com': true,
  'mymail-in.net': true,
  'mymail.ro': true,
  'mynamedot.com': true,
  'mynet.com': true,
  'mynetaddress.com': true,
  'mynetstore.de': true,
  'myotw.net': true,
  'myownemail.com': true,
  'myownfriends.com': true,
  'mypacks.net': true,
  'mypad.com': true,
  'mypartyclip.de': true,
  'mypersonalemail.com': true,
  'myphantomemail.com': true,
  'myplace.com': true,
  'myrambler.ru': true,
  'myrealbox.com': true,
  'myremarq.com': true,
  'mysamp.de': true,
  'myself.com': true,
  'myspaceinc.net': true,
  'myspamless.com': true,
  'mystupidjob.com': true,
  'mytemp.email': true,
  'mytempemail.com': true,
  'mytempmail.com': true,
  'mythirdage.com': true,
  'mytrashmail.com': true,
  'myway.com': true,
  'myworldmail.com': true,
  'n2.com': true,
  'n2baseball.com': true,
  'n2business.com': true,
  'n2mail.com': true,
  'n2soccer.com': true,
  'n2software.com': true,
  'nabc.biz': true,
  'nabuma.com': true,
  'nafe.com': true,
  'nagarealm.com': true,
  'nagpal.net': true,
  'nakedgreens.com': true,
  'name.com': true,
  'nameplanet.com': true,
  'nanaseaikawa.com': true,
  'nandomail.com': true,
  'naplesnews.net': true,
  'naseej.com': true,
  'nate.com': true,
  'nativestar.net': true,
  'nativeweb.net': true,
  'naui.net': true,
  'naver.com': true,
  'navigator.lv': true,
  'navy.org': true,
  'naz.com': true,
  'nc.rr.com': true,
  'nc.ru': true,
  'nchoicemail.com': true,
  'neeva.net': true,
  'nekto.com': true,
  'nekto.net': true,
  'nekto.ru': true,
  'nemra1.com': true,
  'nenter.com': true,
  'neo.rr.com': true,
  'neomailbox.com': true,
  'nepwk.com': true,
  'nervhq.org': true,
  'nervmich.net': true,
  'nervtmich.net': true,
  'net-c.be': true,
  'net-c.ca': true,
  'net-c.cat': true,
  'net-c.com': true,
  'net-c.es': true,
  'net-c.fr': true,
  'net-c.it': true,
  'net-c.lu': true,
  'net-c.nl': true,
  'net-c.pl': true,
  'net-pager.net': true,
  'net-shopping.com': true,
  'net.tf': true,
  'net4b.pt': true,
  'net4you.at': true,
  'netaddres.ru': true,
  'netaddress.ru': true,
  'netbounce.com': true,
  'netbroadcaster.com': true,
  'netby.dk': true,
  'netc.eu': true,
  'netc.fr': true,
  'netc.it': true,
  'netc.lu': true,
  'netc.pl': true,
  'netcenter-vn.net': true,
  'netcity.ru': true,
  'netcmail.com': true,
  'netcourrier.com': true,
  'netexecutive.com': true,
  'netexpressway.com': true,
  'netfirms.com': true,
  'netgenie.com': true,
  'netian.com': true,
  'netizen.com.ar': true,
  'netkushi.com': true,
  'netlane.com': true,
  'netlimit.com': true,
  'netmail.kg': true,
  'netmails.com': true,
  'netmails.net': true,
  'netman.ru': true,
  'netmanor.com': true,
  'netmongol.com': true,
  'netnet.com.sg': true,
  'netnoir.net': true,
  'netpiper.com': true,
  'netposta.net': true,
  'netradiomail.com': true,
  'netralink.com': true,
  'netscape.net': true,
  'netscapeonline.co.uk': true,
  'netspace.net.au': true,
  'netspeedway.com': true,
  'netsquare.com': true,
  'netster.com': true,
  'nettaxi.com': true,
  'nettemail.com': true,
  'netterchef.de': true,
  'netti.fi': true,
  'netvigator.com': true,
  'netzero.com': true,
  'netzero.net': true,
  'netzidiot.de': true,
  'netzoola.com': true,
  'neue-dateien.de': true,
  'neuf.fr': true,
  'neuro.md': true,
  'neustreet.com': true,
  'neverbox.com': true,
  'newap.ru': true,
  'newarbat.net': true,
  'newmail.com': true,
  'newmail.net': true,
  'newmail.ru': true,
  'newsboysmail.com': true,
  'newyork.com': true,
  'newyorkcity.com': true,
  'nextmail.ru': true,
  'nexxmail.com': true,
  'nfmail.com': true,
  'ngs.ru': true,
  'nhmail.com': true,
  'nice-4u.com': true,
  'nicebush.com': true,
  'nicegal.com': true,
  'nicholastse.net': true,
  'nicolastse.com': true,
  'niepodam.pl': true,
  'nightimeuk.com': true,
  'nightmail.com': true,
  'nightmail.ru': true,
  'nikopage.com': true,
  'nikulino.net': true,
  'nimail.com': true,
  'nincsmail.hu': true,
  'ninfan.com': true,
  'nirvanafan.com': true,
  'nm.ru': true,
  'nmail.cf': true,
  'nnh.com': true,
  'nnov.ru': true,
  'no-spam.ws': true,
  'no4ma.ru': true,
  'noavar.com': true,
  'noblepioneer.com': true,
  'nogmailspam.info': true,
  'nomail.pw': true,
  'nomail.xl.cx': true,
  'nomail2me.com': true,
  'nomorespamemails.com': true,
  'nonpartisan.com': true,
  'nonspam.eu': true,
  'nonspammer.de': true,
  'nonstopcinema.com': true,
  'norika-fujiwara.com': true,
  'norikomail.com': true,
  'northgates.net': true,
  'nospam.ze.tc': true,
  'nospam4.us': true,
  'nospamfor.us': true,
  'nospammail.net': true,
  'nospamthanks.info': true,
  'notmailinator.com': true,
  'notsharingmy.info': true,
  'notyouagain.com': true,
  'novogireevo.net': true,
  'novokosino.net': true,
  'nowhere.org': true,
  'nowmymail.com': true,
  'ntelos.net': true,
  'ntlhelp.net': true,
  'ntlworld.com': true,
  'ntscan.com': true,
  'null.net': true,
  'nullbox.info': true,
  'numep.ru': true,
  'nur-fuer-spam.de': true,
  'nurfuerspam.de': true,
  'nus.edu.sg': true,
  'nuvse.com': true,
  'nwldx.com': true,
  'nxt.ru': true,
  'ny.com': true,
  'nybce.com': true,
  'nybella.com': true,
  'nyc.com': true,
  'nycmail.com': true,
  'nz11.com': true,
  'nzoomail.com': true,
  'o-tay.com': true,
  'o2.co.uk': true,
  'o2.pl': true,
  'oaklandas-fan.com': true,
  'oath.com': true,
  'objectmail.com': true,
  'obobbo.com': true,
  'oceanfree.net': true,
  'ochakovo.net': true,
  'odaymail.com': true,
  'oddpost.com': true,
  'odmail.com': true,
  'odnorazovoe.ru': true,
  'office-dateien.de': true,
  'office-email.com': true,
  'officedomain.com': true,
  'offroadwarrior.com': true,
  'oi.com.br': true,
  'oicexchange.com': true,
  'oikrach.com': true,
  'ok.kz': true,
  'ok.net': true,
  'ok.ru': true,
  'okbank.com': true,
  'okhuman.com': true,
  'okmad.com': true,
  'okmagic.com': true,
  'okname.net': true,
  'okuk.com': true,
  'oldbuthealthy.com': true,
  'oldies1041.com': true,
  'oldies104mail.com': true,
  'ole.com': true,
  'olemail.com': true,
  'oligarh.ru': true,
  'olympist.net': true,
  'olypmall.ru': true,
  'omaninfo.com': true,
  'omen.ru': true,
  'ondikoi.com': true,
  'onebox.com': true,
  'onenet.com.ar': true,
  'oneoffemail.com': true,
  'oneoffmail.com': true,
  'onet.com.pl': true,
  'onet.eu': true,
  'onet.pl': true,
  'onewaymail.com': true,
  'oninet.pt': true,
  'onlatedotcom.info': true,
  'online.de': true,
  'online.ie': true,
  'online.ms': true,
  'online.nl': true,
  'online.ru': true,
  'onlinecasinogamblings.com': true,
  'onlinewiz.com': true,
  'onmicrosoft.com': true,
  'onmilwaukee.com': true,
  'onobox.com': true,
  'onvillage.com': true,
  'oopi.org': true,
  'op.pl': true,
  'opayq.com': true,
  'opendiary.com': true,
  'openmailbox.org': true,
  'operafan.com': true,
  'operamail.com': true,
  'opoczta.pl': true,
  'optician.com': true,
  'optonline.net': true,
  'optusnet.com.au': true,
  'orange.fr': true,
  'orange.net': true,
  'orbitel.bg': true,
  'ordinaryamerican.net': true,
  'orgmail.net': true,
  'orthodontist.net': true,
  'osite.com.br': true,
  'oso.com': true,
  'otakumail.com': true,
  'otherinbox.com': true,
  'our-computer.com': true,
  'our-office.com': true,
  'our.st': true,
  'ourbrisbane.com': true,
  'ourklips.com': true,
  'ournet.md': true,
  'outel.com': true,
  'outgun.com': true,
  'outlawspam.com': true,
  'outlook.at': true,
  'outlook.be': true,
  'outlook.cl': true,
  'outlook.co.id': true,
  'outlook.co.il': true,
  'outlook.co.nz': true,
  'outlook.co.th': true,
  'outlook.com': true,
  'outlook.com.au': true,
  'outlook.com.br': true,
  'outlook.com.gr': true,
  'outlook.com.pe': true,
  'outlook.com.tr': true,
  'outlook.com.vn': true,
  'outlook.cz': true,
  'outlook.de': true,
  'outlook.dk': true,
  'outlook.es': true,
  'outlook.fr': true,
  'outlook.hu': true,
  'outlook.ie': true,
  'outlook.in': true,
  'outlook.it': true,
  'outlook.jp': true,
  'outlook.kr': true,
  'outlook.lv': true,
  'outlook.my': true,
  'outlook.nl': true,
  'outlook.ph': true,
  'outlook.pt': true,
  'outlook.sa': true,
  'outlook.sg': true,
  'outlook.sk': true,
  'outloook.com': true,
  'over-the-rainbow.com': true,
  'ovi.com': true,
  'ovpn.to': true,
  'owlpic.com': true,
  'ownmail.net': true,
  'ozbytes.net.au': true,
  'ozemail.com.au': true,
  'ozz.ru': true,
  'pacbell.net': true,
  'pacific-ocean.com': true,
  'pacific-re.com': true,
  'pacificwest.com': true,
  'packersfan.com': true,
  'pagina.de': true,
  'pagons.org': true,
  'paidforsurf.com': true,
  'pakistanmail.com': true,
  'pakistanoye.com': true,
  'palestinemail.com': true,
  'pancakemail.com': true,
  'pandawa.com': true,
  'pandora.be': true,
  'paradiseemail.com': true,
  'paris.com': true,
  'parkjiyoon.com': true,
  'parrot.com': true,
  'parsmail.com': true,
  'partlycloudy.com': true,
  'partybombe.de': true,
  'partyheld.de': true,
  'partynight.at': true,
  'parvazi.com': true,
  'passwordmail.com': true,
  'pathfindermail.com': true,
  'patmail.com': true,
  'patra.net': true,
  'pconnections.net': true,
  'pcpostal.com': true,
  'pcsrock.com': true,
  'pcusers.otherinbox.com': true,
  'peachworld.com': true,
  'pechkin.ru': true,
  'pediatrician.com': true,
  'pekklemail.com': true,
  'pemail.net': true,
  'penpen.com': true,
  'peoplepc.com': true,
  'peopleweb.com': true,
  'pepbot.com': true,
  'perfectmail.com': true,
  'perovo.net': true,
  'perso.be': true,
  'personal.ro': true,
  'personales.com': true,
  'petlover.com': true,
  'petml.com': true,
  'petr.ru': true,
  'pettypool.com': true,
  'pezeshkpour.com': true,
  'pfui.ru': true,
  'phayze.com': true,
  'phone.net': true,
  'photo-impact.eu': true,
  'photographer.net': true,
  'phpbb.uu.gl': true,
  'phreaker.net': true,
  'phus8kajuspa.cu.cc': true,
  'physicist.net': true,
  'pianomail.com': true,
  'pickupman.com': true,
  'picusnet.com': true,
  'piercedallover.com': true,
  'pigeonportal.com': true,
  'pigmail.net': true,
  'pigpig.net': true,
  'pilotemail.com': true,
  'pimagop.com': true,
  'pinoymail.com': true,
  'piracha.net': true,
  'pisem.net': true,
  'pjjkp.com': true,
  'planet-mail.com': true,
  'planet.nl': true,
  'planetaccess.com': true,
  'planetall.com': true,
  'planetarymotion.net': true,
  'planetdirect.com': true,
  'planetearthinter.net': true,
  'planetmail.com': true,
  'planetmail.net': true,
  'planetout.com': true,
  'plasa.com': true,
  'playersodds.com': true,
  'playful.com': true,
  'playstation.sony.com': true,
  'plexolan.de': true,
  'pluno.com': true,
  'plus.com': true,
  'plus.google.com': true,
  'plusmail.com.br': true,
  'pmail.net': true,
  'pobox.com': true,
  'pobox.hu': true,
  'pobox.ru': true,
  'pobox.sk': true,
  'pochta.by': true,
  'pochta.ru': true,
  'pochta.ws': true,
  'pochtamt.ru': true,
  'poczta.fm': true,
  'poczta.onet.pl': true,
  'poetic.com': true,
  'pokemail.net': true,
  'pokemonpost.com': true,
  'pokepost.com': true,
  'polandmail.com': true,
  'polbox.com': true,
  'policeoffice.com': true,
  'politician.com': true,
  'politikerclub.de': true,
  'polizisten-duzer.de': true,
  'polyfaust.com': true,
  'poofy.org': true,
  'poohfan.com': true,
  'pookmail.com': true,
  'pool-sharks.com': true,
  'poond.com': true,
  'pop3.ru': true,
  'popaccount.com': true,
  'popmail.com': true,
  'popsmail.com': true,
  'popstar.com': true,
  'populus.net': true,
  'portableoffice.com': true,
  'portugalmail.com': true,
  'portugalmail.pt': true,
  'portugalnet.com': true,
  'positive-thinking.com': true,
  'post.com': true,
  'post.cz': true,
  'post.sk': true,
  'posta.net': true,
  'posta.ro': true,
  'posta.rosativa.ro.org': true,
  'postaccesslite.com': true,
  'postafiok.hu': true,
  'postafree.com': true,
  'postaweb.com': true,
  'poste.it': true,
  'postfach.cc': true,
  'postinbox.com': true,
  'postino.ch': true,
  'postino.it': true,
  'postmark.net': true,
  'postmaster.co.uk': true,
  'postmaster.twitter.com': true,
  'postpro.net': true,
  'pousa.com': true,
  'powerdivas.com': true,
  'powerfan.com': true,
  'pp.inet.fi': true,
  'praize.com': true,
  'pray247.com': true,
  'predprinimatel.ru': true,
  'premium-mail.fr': true,
  'premiumproducts.com': true,
  'premiumservice.com': true,
  'prepodavatel.ru': true,
  'presidency.com': true,
  'presnya.net': true,
  'press.co.jp': true,
  'prettierthanher.com': true,
  'priest.com': true,
  'primposta.com': true,
  'primposta.hu': true,
  'printesamargareta.ro': true,
  'privacy.net': true,
  'privatdemail.net': true,
  'privy-mail.com': true,
  'privymail.de': true,
  'pro.hu': true,
  'probemail.com': true,
  'prodigy.net': true,
  'prodigy.net.mx': true,
  'professor.ru': true,
  'progetplus.it': true,
  'programist.ru': true,
  'programmer.net': true,
  'programozo.hu': true,
  'proinbox.com': true,
  'project2k.com': true,
  'prokuratura.ru': true,
  'prolaunch.com': true,
  'promessage.com': true,
  'prontomail.com': true,
  'prontomail.compopulus.net': true,
  'protestant.com': true,
  'protonmail.com': true,
  'proxymail.eu': true,
  'prtnx.com': true,
  'prydirect.info': true,
  'psv-supporter.com': true,
  'ptd.net': true,
  'public-files.de': true,
  'public.usa.com': true,
  'publicist.com': true,
  'pulp-fiction.com': true,
  'punkass.com': true,
  'puppy.com.my': true,
  'purinmail.com': true,
  'purpleturtle.com': true,
  'put2.net': true,
  'putthisinyourspamdatabase.com': true,
  'pwrby.com': true,
  'q.com': true,
  'qatar.io': true,
  'qatarmail.com': true,
  'qdice.com': true,
  'qip.ru': true,
  'qmail.com': true,
  'qprfans.com': true,
  'qq.com': true,
  'qrio.com': true,
  'quackquack.com': true,
  'quake.ru': true,
  'quakemail.com': true,
  'qualityservice.com': true,
  'quantentunnel.de': true,
  'qudsmail.com': true,
  'quepasa.com': true,
  'quickhosts.com': true,
  'quickinbox.com': true,
  'quickmail.nl': true,
  'quickmail.ru': true,
  'quicknet.nl': true,
  'quickwebmail.com': true,
  'quiklinks.com': true,
  'quikmail.com': true,
  'qv7.info': true,
  'qwest.net': true,
  'qwestoffice.net': true,
  'r-o-o-t.com': true,
  'r7.com': true,
  'raakim.com': true,
  'racedriver.com': true,
  'racefanz.com': true,
  'racingfan.com.au': true,
  'racingmail.com': true,
  'radicalz.com': true,
  'radiku.ye.vc': true,
  'radiologist.net': true,
  'ragingbull.com': true,
  'ralib.com': true,
  'rambler.ru': true,
  'ranmamail.com': true,
  'rastogi.net': true,
  'ratt-n-roll.com': true,
  'rattle-snake.com': true,
  'raubtierbaendiger.de': true,
  'ravearena.com': true,
  'ravefan.com': true,
  'ravemail.co.za': true,
  'ravemail.com': true,
  'razormail.com': true,
  'rccgmail.org': true,
  'rcn.com': true,
  'rcpt.at': true,
  'realemail.net': true,
  'realestatemail.net': true,
  'reality-concept.club': true,
  'reallyfast.biz': true,
  'reallyfast.info': true,
  'reallymymail.com': true,
  'realradiomail.com': true,
  'realtyagent.com': true,
  'realtyalerts.ca': true,
  'reborn.com': true,
  'recode.me': true,
  'reconmail.com': true,
  'recursor.net': true,
  'recycledmail.com': true,
  'recycler.com': true,
  'recyclermail.com': true,
  'rediff.com': true,
  'rediffmail.com': true,
  'rediffmailpro.com': true,
  'rednecks.com': true,
  'redseven.de': true,
  'redsfans.com': true,
  'redwhitearmy.com': true,
  'regbypass.com': true,
  'reggaefan.com': true,
  'reggafan.com': true,
  'regiononline.com': true,
  'registerednurses.com': true,
  'regspaces.tk': true,
  'reincarnate.com': true,
  'relia.com': true,
  'reliable-mail.com': true,
  'religious.com': true,
  'remail.ga': true,
  'renren.com': true,
  'repairman.com': true,
  'reply.hu': true,
  'reply.ticketmaster.com': true,
  'represantive.com': true,
  'representative.com': true,
  'rescueteam.com': true,
  'resgedvgfed.tk': true,
  'resource.calendar.google.com': true,
  'resumemail.com': true,
  'retailfan.com': true,
  'rexian.com': true,
  'rezai.com': true,
  'rhyta.com': true,
  'richmondhill.com': true,
  'rickymail.com': true,
  'rin.ru': true,
  'ring.by': true,
  'riopreto.com.br': true,
  'rklips.com': true,
  'rmqkr.net': true,
  'rn.com': true,
  'ro.ru': true,
  'roadrunner.com': true,
  'roanokemail.com': true,
  'rock.com': true,
  'rocketmail.com': true,
  'rocketship.com': true,
  'rockfan.com': true,
  'rodrun.com': true,
  'rogers.com': true,
  'rojname.com': true,
  'rol.ro': true,
  'rome.com': true,
  'romymichele.com': true,
  'roosh.com': true,
  'rootprompt.org': true,
  'rotfl.com': true,
  'roughnet.com': true,
  'royal.net': true,
  'rpharmacist.com': true,
  'rr.com': true,
  'rrohio.com': true,
  'rsub.com': true,
  'rt.nl': true,
  'rtrtr.com': true,
  'ru.ru': true,
  'rubyridge.com': true,
  'runbox.com': true,
  'rushpost.com': true,
  'ruttolibero.com': true,
  'rvshop.com': true,
  'rxdoc.biz': true,
  's-mail.com': true,
  's0ny.net': true,
  'sabreshockey.com': true,
  'sacbeemail.com': true,
  'saeuferleber.de': true,
  'safarimail.com': true,
  'safe-mail.net': true,
  'safersignup.de': true,
  'safetymail.info': true,
  'safetypost.de': true,
  'safrica.com': true,
  'sagra.lu': true,
  'sagra.lu.lu': true,
  'sagra.lumarketing.lu': true,
  'sags-per-mail.de': true,
  'sailormoon.com': true,
  'saint-mike.org': true,
  'saintly.com': true,
  'saintmail.net': true,
  'sale-sale-sale.com': true,
  'salehi.net': true,
  'salesperson.net': true,
  'samerica.com': true,
  'samilan.net': true,
  'samiznaetekogo.net': true,
  'sammimail.com': true,
  'sanchezsharks.com': true,
  'sandelf.de': true,
  'sanfranmail.com': true,
  'sanook.com': true,
  'sanriotown.com': true,
  'santanmail.com': true,
  'sapo.pt': true,
  'sativa.ro.org': true,
  'saturnfans.com': true,
  'saturnperformance.com': true,
  'saudia.com': true,
  'savecougars.com': true,
  'savelife.ml': true,
  'saveowls.com': true,
  'sayhi.net': true,
  'saynotospams.com': true,
  'sbcglbal.net': true,
  'sbcglobal.com': true,
  'sbcglobal.net': true,
  'scandalmail.com': true,
  'scanova.in': true,
  'scanova.io': true,
  'scarlet.nl': true,
  'scfn.net': true,
  'schafmail.de': true,
  'schizo.com': true,
  'schmusemail.de': true,
  'schoolemail.com': true,
  'schoolmail.com': true,
  'schoolsucks.com': true,
  'schreib-doch-mal-wieder.de': true,
  'schrott-email.de': true,
  'schweiz.org': true,
  'sci.fi': true,
  'science.com.au': true,
  'scientist.com': true,
  'scifianime.com': true,
  'scotland.com': true,
  'scotlandmail.com': true,
  'scottishmail.co.uk': true,
  'scottishtories.com': true,
  'scottsboro.org': true,
  'scrapbookscrapbook.com': true,
  'scubadiving.com': true,
  'seanet.com': true,
  'search.ua': true,
  'search417.com': true,
  'searchwales.com': true,
  'sebil.com': true,
  'seckinmail.com': true,
  'secret-police.com': true,
  'secretarias.com': true,
  'secretary.net': true,
  'secretemail.de': true,
  'secretservices.net': true,
  'secure-mail.biz': true,
  'secure-mail.cc': true,
  'seductive.com': true,
  'seekstoyboy.com': true,
  'seguros.com.br': true,
  'sekomaonline.com': true,
  'selfdestructingmail.com': true,
  'sellingspree.com': true,
  'send.hu': true,
  'sendmail.ru': true,
  'sendme.cz': true,
  'sendspamhere.com': true,
  'senseless-entertainment.com': true,
  'sent.as': true,
  'sent.at': true,
  'sent.com': true,
  'sentrismail.com': true,
  'serga.com.ar': true,
  'servemymail.com': true,
  'servermaps.net': true,
  'services391.com': true,
  'sesmail.com': true,
  'sexmagnet.com': true,
  'seznam.cz': true,
  'sfr.fr': true,
  'shahweb.net': true,
  'shaniastuff.com': true,
  'shared-files.de': true,
  'sharedmailbox.org': true,
  'sharewaredevelopers.com': true,
  'sharklasers.com': true,
  'sharmaweb.com': true,
  'shaw.ca': true,
  'she.com': true,
  'shellov.net': true,
  'shieldedmail.com': true,
  'shieldemail.com': true,
  'shiftmail.com': true,
  'shinedyoureyes.com': true,
  'shitaway.cf': true,
  'shitaway.cu.cc': true,
  'shitaway.ga': true,
  'shitaway.gq': true,
  'shitaway.ml': true,
  'shitaway.tk': true,
  'shitaway.usa.cc': true,
  'shitmail.de': true,
  'shitmail.me': true,
  'shitmail.org': true,
  'shitware.nl': true,
  'shmeriously.com': true,
  'shockinmytown.cu.cc': true,
  'shootmail.com': true,
  'shortmail.com': true,
  'shortmail.net': true,
  'shotgun.hu': true,
  'showfans.com': true,
  'showslow.de': true,
  'shqiptar.eu': true,
  'shuf.com': true,
  'sialkotcity.com': true,
  'sialkotian.com': true,
  'sialkotoye.com': true,
  'sibmail.com': true,
  'sify.com': true,
  'sigaret.net': true,
  'silkroad.net': true,
  'simbamail.fm': true,
  'sina.cn': true,
  'sina.com': true,
  'sinamail.com': true,
  'singapore.com': true,
  'singles4jesus.com': true,
  'singmail.com': true,
  'singnet.com.sg': true,
  'singpost.com': true,
  'sinnlos-mail.de': true,
  'sirindia.com': true,
  'siteposter.net': true,
  'skafan.com': true,
  'skeefmail.com': true,
  'skim.com': true,
  'skizo.hu': true,
  'skrx.tk': true,
  'skunkbox.com': true,
  'sky.com': true,
  'skynet.be': true,
  'slamdunkfan.com': true,
  'slapsfromlastnight.com': true,
  'slaskpost.se': true,
  'slave-auctions.net': true,
  'slickriffs.co.uk': true,
  'slingshot.com': true,
  'slippery.email': true,
  'slipry.net': true,
  'slo.net': true,
  'slotter.com': true,
  'sm.westchestergov.com': true,
  'smap.4nmv.ru': true,
  'smapxsmap.net': true,
  'smashmail.de': true,
  'smellfear.com': true,
  'smellrear.com': true,
  'smileyface.comsmithemail.net': true,
  'sminkymail.com': true,
  'smoothmail.com': true,
  'sms.at': true,
  'smtp.ru': true,
  'snail-mail.net': true,
  'snail-mail.ney': true,
  'snakebite.com': true,
  'snakemail.com': true,
  'sndt.net': true,
  'sneakemail.com': true,
  'sneakmail.de': true,
  'snet.net': true,
  'sniper.hu': true,
  'snkmail.com': true,
  'snoopymail.com': true,
  'snowboarding.com': true,
  'snowdonia.net': true,
  'so-simple.org': true,
  'socamail.com': true,
  'socceraccess.com': true,
  'socceramerica.net': true,
  'soccermail.com': true,
  'soccermomz.com': true,
  'social-mailer.tk': true,
  'socialworker.net': true,
  'sociologist.com': true,
  'sofimail.com': true,
  'sofort-mail.de': true,
  'sofortmail.de': true,
  'softhome.net': true,
  'sogetthis.com': true,
  'sogou.com': true,
  'sohu.com': true,
  'sokolniki.net': true,
  'sol.dk': true,
  'solar-impact.pro': true,
  'solcon.nl': true,
  'soldier.hu': true,
  'solution4u.com': true,
  'solvemail.info': true,
  'songwriter.net': true,
  'sonnenkinder.org': true,
  'soodomail.com': true,
  'soodonims.com': true,
  'soon.com': true,
  'soulfoodcookbook.com': true,
  'soundofmusicfans.com': true,
  'southparkmail.com': true,
  'sovsem.net': true,
  'sp.nl': true,
  'space-bank.com': true,
  'space-man.com': true,
  'space-ship.com': true,
  'space-travel.com': true,
  'space.com': true,
  'spaceart.com': true,
  'spacebank.com': true,
  'spacemart.com': true,
  'spacetowns.com': true,
  'spacewar.com': true,
  'spainmail.com': true,
  'spam.2012-2016.ru': true,
  'spam4.me': true,
  'spamail.de': true,
  'spamarrest.com': true,
  'spamavert.com': true,
  'spambob.com': true,
  'spambob.net': true,
  'spambob.org': true,
  'spambog.com': true,
  'spambog.de': true,
  'spambog.net': true,
  'spambog.ru': true,
  'spambooger.com': true,
  'spambox.info': true,
  'spambox.us': true,
  'spamcannon.com': true,
  'spamcannon.net': true,
  'spamcero.com': true,
  'spamcon.org': true,
  'spamcorptastic.com': true,
  'spamcowboy.com': true,
  'spamcowboy.net': true,
  'spamcowboy.org': true,
  'spamday.com': true,
  'spamdecoy.net': true,
  'spameater.com': true,
  'spameater.org': true,
  'spamex.com': true,
  'spamfree.eu': true,
  'spamfree24.com': true,
  'spamfree24.de': true,
  'spamfree24.info': true,
  'spamfree24.net': true,
  'spamfree24.org': true,
  'spamgoes.in': true,
  'spamgourmet.com': true,
  'spamgourmet.net': true,
  'spamgourmet.org': true,
  'spamherelots.com': true,
  'spamhereplease.com': true,
  'spamhole.com': true,
  'spamify.com': true,
  'spaminator.de': true,
  'spamkill.info': true,
  'spaml.com': true,
  'spaml.de': true,
  'spammotel.com': true,
  'spamobox.com': true,
  'spamoff.de': true,
  'spamslicer.com': true,
  'spamspot.com': true,
  'spamstack.net': true,
  'spamthis.co.uk': true,
  'spamtroll.net': true,
  'spankthedonkey.com': true,
  'spartapiet.com': true,
  'spazmail.com': true,
  'speed.1s.fr': true,
  'speedemail.net': true,
  'speedpost.net': true,
  'speedrules.com': true,
  'speedrulz.com': true,
  'speedy.com.ar': true,
  'speedymail.org': true,
  'sperke.net': true,
  'spils.com': true,
  'spinfinder.com': true,
  'spiritseekers.com': true,
  'spl.at': true,
  'spoko.pl': true,
  'spoofmail.de': true,
  'sportemail.com': true,
  'sportmail.ru': true,
  'sportsmail.com': true,
  'sporttruckdriver.com': true,
  'spray.no': true,
  'spray.se': true,
  'spybox.de': true,
  'spymac.com': true,
  'sraka.xyz': true,
  'srilankan.net': true,
  'ssl-mail.com': true,
  'st-davids.net': true,
  'stade.fr': true,
  'stalag13.com': true,
  'standalone.net': true,
  'starbuzz.com': true,
  'stargateradio.com': true,
  'starmail.com': true,
  'starmail.org': true,
  'starmedia.com': true,
  'starplace.com': true,
  'starspath.com': true,
  'start.com.au': true,
  'starting-point.com': true,
  'startkeys.com': true,
  'startrekmail.com': true,
  'starwars-fans.com': true,
  'stealthmail.com': true,
  'stillchronic.com': true,
  'stinkefinger.net': true,
  'stipte.nl': true,
  'stockracer.com': true,
  'stockstorm.com': true,
  'stoned.com': true,
  'stones.com': true,
  'stop-my-spam.pp.ua': true,
  'stopdropandroll.com': true,
  'storksite.com': true,
  'streber24.de': true,
  'streetwisemail.com': true,
  'stribmail.com': true,
  'strompost.com': true,
  'strongguy.com': true,
  'student.su': true,
  'studentcenter.org': true,
  'stuffmail.de': true,
  'subnetwork.com': true,
  'subram.com': true,
  'sudanmail.net': true,
  'sudolife.me': true,
  'sudolife.net': true,
  'sudomail.biz': true,
  'sudomail.com': true,
  'sudomail.net': true,
  'sudoverse.com': true,
  'sudoverse.net': true,
  'sudoweb.net': true,
  'sudoworld.com': true,
  'sudoworld.net': true,
  'sueddeutsche.de': true,
  'suhabi.com': true,
  'suisse.org': true,
  'sukhumvit.net': true,
  'sul.com.br': true,
  'sunmail1.com': true,
  'sunpoint.net': true,
  'sunrise-sunset.com': true,
  'sunsgame.com': true,
  'sunumail.sn': true,
  'suomi24.fi': true,
  'super-auswahl.de': true,
  'superdada.com': true,
  'supereva.it': true,
  'supergreatmail.com': true,
  'supermail.ru': true,
  'supermailer.jp': true,
  'superman.ru': true,
  'superposta.com': true,
  'superrito.com': true,
  'superstachel.de': true,
  'surat.com': true,
  'suremail.info': true,
  'surf3.net': true,
  'surfree.com': true,
  'surfsupnet.net': true,
  'surfy.net': true,
  'surgical.net': true,
  'surimail.com': true,
  'survivormail.com': true,
  'susi.ml': true,
  'sviblovo.net': true,
  'svk.jp': true,
  'swbell.net': true,
  'sweb.cz': true,
  'swedenmail.com': true,
  'sweetville.net': true,
  'sweetxxx.de': true,
  'swift-mail.com': true,
  'swiftdesk.com': true,
  'swingeasyhithard.com': true,
  'swingfan.com': true,
  'swipermail.zzn.com': true,
  'swirve.com': true,
  'swissinfo.org': true,
  'swissmail.com': true,
  'swissmail.net': true,
  'switchboardmail.com': true,
  'switzerland.org': true,
  'sx172.com': true,
  'sympatico.ca': true,
  'syom.com': true,
  'syriamail.com': true,
  't-online.de': true,
  't.psh.me': true,
  't2mail.com': true,
  'tafmail.com': true,
  'takoe.com': true,
  'takoe.net': true,
  'takuyakimura.com': true,
  'talk21.com': true,
  'talkcity.com': true,
  'talkinator.com': true,
  'talktalk.co.uk': true,
  'tamb.ru': true,
  'tamil.com': true,
  'tampabay.rr.com': true,
  'tangmonkey.com': true,
  'tankpolice.com': true,
  'taotaotano.com': true,
  'tatanova.com': true,
  'tattooedallover.com': true,
  'tattoofanatic.com': true,
  'tbwt.com': true,
  'tcc.on.ca': true,
  'tds.net': true,
  'teacher.com': true,
  'teachermail.net': true,
  'teachers.org': true,
  'teamdiscovery.com': true,
  'teamtulsa.net': true,
  'tech-center.com': true,
  'tech4peace.org': true,
  'techemail.com': true,
  'techie.com': true,
  'technisamail.co.za': true,
  'technologist.com': true,
  'technologyandstocks.com': true,
  'techpointer.com': true,
  'techscout.com': true,
  'techseek.com': true,
  'techsniper.com': true,
  'techspot.com': true,
  'teenagedirtbag.com': true,
  'teewars.org': true,
  'tele2.nl': true,
  'telebot.com': true,
  'telebot.net': true,
  'telefonica.net': true,
  'teleline.es': true,
  'telenet.be': true,
  'telepac.pt': true,
  'telerymd.com': true,
  'teleserve.dynip.com': true,
  'teletu.it': true,
  'teleworm.com': true,
  'teleworm.us': true,
  'telfort.nl': true,
  'telfortglasvezel.nl': true,
  'telinco.net': true,
  'telkom.net': true,
  'telpage.net': true,
  'telstra.com': true,
  'telstra.com.au': true,
  'temp-mail.com': true,
  'temp-mail.de': true,
  'temp-mail.org': true,
  'temp-mail.ru': true,
  'temp.headstrong.de': true,
  'tempail.com': true,
  'tempe-mail.com': true,
  'tempemail.biz': true,
  'tempemail.co.za': true,
  'tempemail.com': true,
  'tempemail.net': true,
  'tempinbox.co.uk': true,
  'tempinbox.com': true,
  'tempmail.eu': true,
  'tempmail.it': true,
  'tempmail.us': true,
  'tempmail2.com': true,
  'tempmaildemo.com': true,
  'tempmailer.com': true,
  'tempmailer.de': true,
  'tempomail.fr': true,
  'temporarioemail.com.br': true,
  'temporaryemail.net': true,
  'temporaryemail.us': true,
  'temporaryforwarding.com': true,
  'temporaryinbox.com': true,
  'temporarymailaddress.com': true,
  'tempthe.net': true,
  'tempymail.com': true,
  'temtulsa.net': true,
  'tenchiclub.com': true,
  'tenderkiss.com': true,
  'tennismail.com': true,
  'terminverpennt.de': true,
  'terra.cl': true,
  'terra.com': true,
  'terra.com.ar': true,
  'terra.com.br': true,
  'terra.com.pe': true,
  'terra.es': true,
  'test.com': true,
  'test.de': true,
  'tfanus.com.er': true,
  'tfbnw.net': true,
  'tfz.net': true,
  'tgasa.ru': true,
  'tgma.ru': true,
  'tgngu.ru': true,
  'tgu.ru': true,
  'thai.com': true,
  'thaimail.com': true,
  'thaimail.net': true,
  'thanksnospam.info': true,
  'thankyou2010.com': true,
  'thc.st': true,
  'the-african.com': true,
  'the-airforce.com': true,
  'the-aliens.com': true,
  'the-american.com': true,
  'the-animal.com': true,
  'the-army.com': true,
  'the-astronaut.com': true,
  'the-beauty.com': true,
  'the-big-apple.com': true,
  'the-biker.com': true,
  'the-boss.com': true,
  'the-brazilian.com': true,
  'the-canadian.com': true,
  'the-canuck.com': true,
  'the-captain.com': true,
  'the-chinese.com': true,
  'the-country.com': true,
  'the-cowboy.com': true,
  'the-davis-home.com': true,
  'the-dutchman.com': true,
  'the-eagles.com': true,
  'the-englishman.com': true,
  'the-fastest.net': true,
  'the-fool.com': true,
  'the-frenchman.com': true,
  'the-galaxy.net': true,
  'the-genius.com': true,
  'the-gentleman.com': true,
  'the-german.com': true,
  'the-gremlin.com': true,
  'the-hooligan.com': true,
  'the-italian.com': true,
  'the-japanese.com': true,
  'the-lair.com': true,
  'the-madman.com': true,
  'the-mailinglist.com': true,
  'the-marine.com': true,
  'the-master.com': true,
  'the-mexican.com': true,
  'the-ministry.com': true,
  'the-monkey.com': true,
  'the-newsletter.net': true,
  'the-pentagon.com': true,
  'the-police.com': true,
  'the-prayer.com': true,
  'the-professional.com': true,
  'the-quickest.com': true,
  'the-russian.com': true,
  'the-seasiders.com': true,
  'the-snake.com': true,
  'the-spaceman.com': true,
  'the-stock-market.com': true,
  'the-student.net': true,
  'the-whitehouse.net': true,
  'the-wild-west.com': true,
  'the18th.com': true,
  'thecoolguy.com': true,
  'thecriminals.com': true,
  'thedoghousemail.com': true,
  'thedorm.com': true,
  'theend.hu': true,
  'theglobe.com': true,
  'thegolfcourse.com': true,
  'thegooner.com': true,
  'theheadoffice.com': true,
  'theinternetemail.com': true,
  'thelanddownunder.com': true,
  'thelimestones.com': true,
  'themail.com': true,
  'themillionare.net': true,
  'theoffice.net': true,
  'theplate.com': true,
  'thepokerface.com': true,
  'thepostmaster.net': true,
  'theraces.com': true,
  'theracetrack.com': true,
  'therapist.net': true,
  'thereisnogod.com': true,
  'thesimpsonsfans.com': true,
  'thestreetfighter.com': true,
  'theteebox.com': true,
  'thewatercooler.com': true,
  'thewebpros.co.uk': true,
  'thewizzard.com': true,
  'thewizzkid.com': true,
  'thexyz.ca': true,
  'thexyz.cn': true,
  'thexyz.com': true,
  'thexyz.es': true,
  'thexyz.fr': true,
  'thexyz.in': true,
  'thexyz.mobi': true,
  'thexyz.net': true,
  'thexyz.org': true,
  'thezhangs.net': true,
  'thirdage.com': true,
  'thisgirl.com': true,
  'thisisnotmyrealemail.com': true,
  'thismail.net': true,
  'thoic.com': true,
  'thraml.com': true,
  'thrott.com': true,
  'throwam.com': true,
  'throwawayemailaddress.com': true,
  'thundermail.com': true,
  'tibetemail.com': true,
  'tidni.com': true,
  'tilien.com': true,
  'timein.net': true,
  'timormail.com': true,
  'tin.it': true,
  'tipsandadvice.com': true,
  'tiran.ru': true,
  'tiscali.at': true,
  'tiscali.be': true,
  'tiscali.co.uk': true,
  'tiscali.it': true,
  'tiscali.lu': true,
  'tiscali.se': true,
  'tittbit.in': true,
  'tizi.com': true,
  'tkcity.com': true,
  'tlcfan.com': true,
  'tmail.ws': true,
  'tmailinator.com': true,
  'tmicha.net': true,
  'toast.com': true,
  'toke.com': true,
  'tokyo.com': true,
  'tom.com': true,
  'toolsource.com': true,
  'toomail.biz': true,
  'toothfairy.com': true,
  'topchat.com': true,
  'topgamers.co.uk': true,
  'topletter.com': true,
  'topmail-files.de': true,
  'topmail.com.ar': true,
  'topranklist.de': true,
  'topsurf.com': true,
  'topteam.bg': true,
  'toquedequeda.com': true,
  'torba.com': true,
  'torchmail.com': true,
  'torontomail.com': true,
  'tortenboxer.de': true,
  'totalmail.com': true,
  'totalmail.de': true,
  'totalmusic.net': true,
  'totalsurf.com': true,
  'toughguy.net': true,
  'townisp.com': true,
  'tpg.com.au': true,
  'tradermail.info': true,
  'trainspottingfan.com': true,
  'trash-amil.com': true,
  'trash-mail.at': true,
  'trash-mail.com': true,
  'trash-mail.de': true,
  'trash-mail.ga': true,
  'trash-mail.ml': true,
  'trash2009.com': true,
  'trash2010.com': true,
  'trash2011.com': true,
  'trashdevil.com': true,
  'trashdevil.de': true,
  'trashemail.de': true,
  'trashmail.at': true,
  'trashmail.com': true,
  'trashmail.de': true,
  'trashmail.me': true,
  'trashmail.net': true,
  'trashmail.org': true,
  'trashmailer.com': true,
  'trashymail.com': true,
  'trashymail.net': true,
  'travel.li': true,
  'trayna.com': true,
  'trbvm.com': true,
  'trbvn.com': true,
  'trevas.net': true,
  'trialbytrivia.com': true,
  'trialmail.de': true,
  'trickmail.net': true,
  'trillianpro.com': true,
  'trimix.cn': true,
  'tritium.net': true,
  'trjam.net': true,
  'trmailbox.com': true,
  'tropicalstorm.com': true,
  'truckeremail.net': true,
  'truckers.com': true,
  'truckerz.com': true,
  'truckracer.com': true,
  'truckracers.com': true,
  'trust-me.com': true,
  'truth247.com': true,
  'truthmail.com': true,
  'tsamail.co.za': true,
  'ttml.co.in': true,
  'tulipsmail.net': true,
  'tunisiamail.com': true,
  'turboprinz.de': true,
  'turboprinzessin.de': true,
  'turkey.com': true,
  'turual.com': true,
  'tushino.net': true,
  'tut.by': true,
  'tvcablenet.be': true,
  'tverskie.net': true,
  'tverskoe.net': true,
  'tvnet.lv': true,
  'tvstar.com': true,
  'twc.com': true,
  'twcny.com': true,
  'twentylove.com': true,
  'twinmail.de': true,
  'twinstarsmail.com': true,
  'tx.rr.com': true,
  'tycoonmail.com': true,
  'tyldd.com': true,
  'typemail.com': true,
  'tyt.by': true,
  'u14269.ml': true,
  'u2club.com': true,
  'ua.fm': true,
  'uae.ac': true,
  'uaemail.com': true,
  'ubbi.com': true,
  'ubbi.com.br': true,
  'uboot.com': true,
  'uggsrock.com': true,
  'uk2.net': true,
  'uk2k.com': true,
  'uk2net.com': true,
  'uk7.net': true,
  'uk8.net': true,
  'ukbuilder.com': true,
  'ukcool.com': true,
  'ukdreamcast.com': true,
  'ukmail.org': true,
  'ukmax.com': true,
  'ukr.net': true,
  'ukrpost.net': true,
  'ukrtop.com': true,
  'uku.co.uk': true,
  'ultapulta.com': true,
  'ultimatelimos.com': true,
  'ultrapostman.com': true,
  'umail.net': true,
  'ummah.org': true,
  'umpire.com': true,
  'unbounded.com': true,
  'underwriters.com': true,
  'unforgettable.com': true,
  'uni.de': true,
  'uni.de.de': true,
  'uni.demailto.de': true,
  'unican.es': true,
  'unihome.com': true,
  'universal.pt': true,
  'uno.ee': true,
  'uno.it': true,
  'unofree.it': true,
  'unomail.com': true,
  'unterderbruecke.de': true,
  'uogtritons.com': true,
  'uol.com.ar': true,
  'uol.com.br': true,
  'uol.com.co': true,
  'uol.com.mx': true,
  'uol.com.ve': true,
  'uole.com': true,
  'uole.com.ve': true,
  'uolmail.com': true,
  'uomail.com': true,
  'upc.nl': true,
  'upcmail.nl': true,
  'upf.org': true,
  'upliftnow.com': true,
  'uplipht.com': true,
  'uraniomail.com': true,
  'ureach.com': true,
  'urgentmail.biz': true,
  'uroid.com': true,
  'us.af': true,
  'usa.com': true,
  'usa.net': true,
  'usaaccess.net': true,
  'usanetmail.com': true,
  'used-product.fr': true,
  'userbeam.com': true,
  'usermail.com': true,
  'username.e4ward.com': true,
  'userzap.com': true,
  'usma.net': true,
  'usmc.net': true,
  'uswestmail.net': true,
  'uymail.com': true,
  'uyuyuy.com': true,
  'uzhe.net': true,
  'v-sexi.com': true,
  'v8email.com': true,
  'vaasfc4.tk': true,
  'vahoo.com': true,
  'valemail.net': true,
  'valudeal.net': true,
  'vampirehunter.com': true,
  'varbizmail.com': true,
  'vcmail.com': true,
  'velnet.co.uk': true,
  'velnet.com': true,
  'velocall.com': true,
  'veloxmail.com.br': true,
  'venompen.com': true,
  'verizon.net': true,
  'verizonmail.com': true,
  'verlass-mich-nicht.de': true,
  'versatel.nl': true,
  'verticalheaven.com': true,
  'veryfast.biz': true,
  'veryrealemail.com': true,
  'veryspeedy.net': true,
  'vfemail.net': true,
  'vickaentb.tk': true,
  'videotron.ca': true,
  'viditag.com': true,
  'viewcastmedia.com': true,
  'viewcastmedia.net': true,
  'vinbazar.com': true,
  'violinmakers.co.uk': true,
  'vip.126.com': true,
  'vip.21cn.com': true,
  'vip.citiz.net': true,
  'vip.gr': true,
  'vip.onet.pl': true,
  'vip.qq.com': true,
  'vip.sina.com': true,
  'vipmail.ru': true,
  'viralplays.com': true,
  'virgilio.it': true,
  'virgin.net': true,
  'virginbroadband.com.au': true,
  'virginmedia.com': true,
  'virtual-mail.com': true,
  'virtualactive.com': true,
  'virtualguam.com': true,
  'virtualmail.com': true,
  'visitmail.com': true,
  'visitweb.com': true,
  'visto.com': true,
  'visualcities.com': true,
  'vivavelocity.com': true,
  'vivianhsu.net': true,
  'viwanet.ru': true,
  'vjmail.com': true,
  'vjtimail.com': true,
  'vkcode.ru': true,
  'vlcity.ru': true,
  'vlmail.com': true,
  'vnet.citiz.net': true,
  'vnn.vn': true,
  'vnukovo.net': true,
  'vodafone.nl': true,
  'vodafonethuis.nl': true,
  'voila.fr': true,
  'volcanomail.com': true,
  'vollbio.de': true,
  'volloeko.de': true,
  'vomoto.com': true,
  'voo.be': true,
  'vorsicht-bissig.de': true,
  'vorsicht-scharf.de': true,
  'vote-democrats.com': true,
  'vote-hillary.com': true,
  'vote-republicans.com': true,
  'vote4gop.org': true,
  'votenet.com': true,
  'vovan.ru': true,
  'vp.pl': true,
  'vpn.st': true,
  'vr9.com': true,
  'vsimcard.com': true,
  'vubby.com': true,
  'vyhino.net': true,
  'w3.to': true,
  'wahoye.com': true,
  'walala.org': true,
  'wales2000.net': true,
  'walkmail.net': true,
  'walkmail.ru': true,
  'walla.co.il': true,
  'wam.co.za': true,
  'wanaboo.com': true,
  'wanadoo.co.uk': true,
  'wanadoo.es': true,
  'wanadoo.fr': true,
  'wapda.com': true,
  'war-im-urlaub.de': true,
  'warmmail.com': true,
  'warpmail.net': true,
  'warrior.hu': true,
  'wasteland.rfc822.org': true,
  'watchmail.com': true,
  'waumail.com': true,
  'wazabi.club': true,
  'wbdet.com': true,
  'wearab.net': true,
  'web-contact.info': true,
  'web-emailbox.eu': true,
  'web-ideal.fr': true,
  'web-mail.com.ar': true,
  'web-mail.pp.ua': true,
  'web-police.com': true,
  'web.de': true,
  'webaddressbook.com': true,
  'webadicta.org': true,
  'webave.com': true,
  'webbworks.com': true,
  'webcammail.com': true,
  'webcity.ca': true,
  'webcontact-france.eu': true,
  'webdream.com': true,
  'webemail.me': true,
  'webemaillist.com': true,
  'webinbox.com': true,
  'webindia123.com': true,
  'webjump.com': true,
  'webm4il.info': true,
  'webmail.bellsouth.net': true,
  'webmail.blue': true,
  'webmail.co.yu': true,
  'webmail.co.za': true,
  'webmail.fish': true,
  'webmail.hu': true,
  'webmail.lawyer': true,
  'webmail.ru': true,
  'webmail.wiki': true,
  'webmails.com': true,
  'webmailv.com': true,
  'webname.com': true,
  'webprogramming.com': true,
  'webskulker.com': true,
  'webstation.com': true,
  'websurfer.co.za': true,
  'webtopmail.com': true,
  'webtribe.net': true,
  'webuser.in': true,
  'wee.my': true,
  'weedmail.com': true,
  'weekmail.com': true,
  'weekonline.com': true,
  'wefjo.grn.cc': true,
  'weg-werf-email.de': true,
  'wegas.ru': true,
  'wegwerf-emails.de': true,
  'wegwerfadresse.de': true,
  'wegwerfemail.com': true,
  'wegwerfemail.de': true,
  'wegwerfmail.de': true,
  'wegwerfmail.info': true,
  'wegwerfmail.net': true,
  'wegwerfmail.org': true,
  'wegwerpmailadres.nl': true,
  'wehshee.com': true,
  'weibsvolk.de': true,
  'weibsvolk.org': true,
  'weinenvorglueck.de': true,
  'welsh-lady.com': true,
  'wesleymail.com': true,
  'westnet.com': true,
  'westnet.com.au': true,
  'wetrainbayarea.com': true,
  'wfgdfhj.tk': true,
  'wh4f.org': true,
  'whale-mail.com': true,
  'whartontx.com': true,
  'whatiaas.com': true,
  'whatpaas.com': true,
  'wheelweb.com': true,
  'whipmail.com': true,
  'whoever.com': true,
  'wholefitness.com': true,
  'whoopymail.com': true,
  'whtjddn.33mail.com': true,
  'whyspam.me': true,
  'wickedmail.com': true,
  'wickmail.net': true,
  'wideopenwest.com': true,
  'wildmail.com': true,
  'wilemail.com': true,
  'will-hier-weg.de': true,
  'willhackforfood.biz': true,
  'willselfdestruct.com': true,
  'windowslive.com': true,
  'windrivers.net': true,
  'windstream.com': true,
  'windstream.net': true,
  'winemaven.info': true,
  'wingnutz.com': true,
  'winmail.com.au': true,
  'winning.com': true,
  'winrz.com': true,
  'wir-haben-nachwuchs.de': true,
  'wir-sind-cool.org': true,
  'wirsindcool.de': true,
  'witty.com': true,
  'wiz.cc': true,
  'wkbwmail.com': true,
  'wmail.cf': true,
  'wo.com.cn': true,
  'woh.rr.com': true,
  'wolf-web.com': true,
  'wolke7.net': true,
  'wollan.info': true,
  'wombles.com': true,
  'women-at-work.org': true,
  'women-only.net': true,
  'wonder-net.com': true,
  'wongfaye.com': true,
  'wooow.it': true,
  'work4teens.com': true,
  'worker.com': true,
  'workmail.co.za': true,
  'workmail.com': true,
  'worldbreak.com': true,
  'worldemail.com': true,
  'worldmailer.com': true,
  'worldnet.att.net': true,
  'wormseo.cn': true,
  'wosaddict.com': true,
  'wouldilie.com': true,
  'wovz.cu.cc': true,
  'wow.com': true,
  'wowgirl.com': true,
  'wowmail.com': true,
  'wowway.com': true,
  'wp.pl': true,
  'wptamail.com': true,
  'wrestlingpages.com': true,
  'wrexham.net': true,
  'writeme.com': true,
  'writemeback.com': true,
  'writeremail.com': true,
  'wronghead.com': true,
  'wrongmail.com': true,
  'wtvhmail.com': true,
  'wwdg.com': true,
  'www.com': true,
  'www.e4ward.com': true,
  'www.mailinator.com': true,
  'www2000.net': true,
  'wwwnew.eu': true,
  'wx88.net': true,
  'wxs.net': true,
  'wyrm.supernews.com': true,
  'x-mail.net': true,
  'x-networks.net': true,
  'x.ip6.li': true,
  'x5g.com': true,
  'xagloo.com': true,
  'xaker.ru': true,
  'xd.ae': true,
  'xemaps.com': true,
  'xents.com': true,
  'xing886.uu.gl': true,
  'xmail.com': true,
  'xmaily.com': true,
  'xmastime.com': true,
  'xmenfans.com': true,
  'xms.nl': true,
  'xmsg.com': true,
  'xoom.com': true,
  'xoommail.com': true,
  'xoxox.cc': true,
  'xoxy.net': true,
  'xpectmore.com': true,
  'xpressmail.zzn.com': true,
  'xs4all.nl': true,
  'xsecurity.org': true,
  'xsmail.com': true,
  'xtra.co.nz': true,
  'xtram.com': true,
  'xuno.com': true,
  'xww.ro': true,
  'xy9ce.tk': true,
  'xyz.am': true,
  'xyzfree.net': true,
  'xzapmail.com': true,
  'y7mail.com': true,
  'ya.ru': true,
  'yada-yada.com': true,
  'yaho.com': true,
  'yahoo.ae': true,
  'yahoo.at': true,
  'yahoo.be': true,
  'yahoo.ca': true,
  'yahoo.ch': true,
  'yahoo.cn': true,
  'yahoo.co': true,
  'yahoo.co.id': true,
  'yahoo.co.il': true,
  'yahoo.co.in': true,
  'yahoo.co.jp': true,
  'yahoo.co.kr': true,
  'yahoo.co.nz': true,
  'yahoo.co.th': true,
  'yahoo.co.uk': true,
  'yahoo.co.za': true,
  'yahoo.com': true,
  'yahoo.com.ar': true,
  'yahoo.com.au': true,
  'yahoo.com.br': true,
  'yahoo.com.cn': true,
  'yahoo.com.co': true,
  'yahoo.com.hk': true,
  'yahoo.com.is': true,
  'yahoo.com.mx': true,
  'yahoo.com.my': true,
  'yahoo.com.ph': true,
  'yahoo.com.ru': true,
  'yahoo.com.sg': true,
  'yahoo.com.tr': true,
  'yahoo.com.tw': true,
  'yahoo.com.vn': true,
  'yahoo.cz': true,
  'yahoo.de': true,
  'yahoo.dk': true,
  'yahoo.es': true,
  'yahoo.fi': true,
  'yahoo.fr': true,
  'yahoo.gr': true,
  'yahoo.hu': true,
  'yahoo.ie': true,
  'yahoo.in': true,
  'yahoo.it': true,
  'yahoo.jp': true,
  'yahoo.net': true,
  'yahoo.nl': true,
  'yahoo.no': true,
  'yahoo.pl': true,
  'yahoo.pt': true,
  'yahoo.ro': true,
  'yahoo.ru': true,
  'yahoo.se': true,
  'yahoofs.com': true,
  'yahoomail.com': true,
  'yalla.com': true,
  'yalla.com.lb': true,
  'yalook.com': true,
  'yam.com': true,
  'yandex.com': true,
  'yandex.mail': true,
  'yandex.pl': true,
  'yandex.ru': true,
  'yandex.ua': true,
  'yapost.com': true,
  'yapped.net': true,
  'yawmail.com': true,
  'yclub.com': true,
  'yeah.net': true,
  'yebox.com': true,
  'yeehaa.com': true,
  'yehaa.com': true,
  'yehey.com': true,
  'yemenmail.com': true,
  'yep.it': true,
  'yepmail.net': true,
  'yert.ye.vc': true,
  'yesbox.net': true,
  'yesey.net': true,
  'yeswebmaster.com': true,
  'ygm.com': true,
  'yifan.net': true,
  'ymail.com': true,
  'ynnmail.com': true,
  'yogamaven.com': true,
  'yogotemail.com': true,
  'yomail.info': true,
  'yopmail.com': true,
  'yopmail.fr': true,
  'yopmail.net': true,
  'yopmail.org': true,
  'yopmail.pp.ua': true,
  'yopolis.com': true,
  'yopweb.com': true,
  'youareadork.com': true,
  'youmailr.com': true,
  'youpy.com': true,
  'your-house.com': true,
  'your-mail.com': true,
  'yourdomain.com': true,
  'yourinbox.com': true,
  'yourlifesucks.cu.cc': true,
  'yourlover.net': true,
  'yournightmare.com': true,
  'yours.com': true,
  'yourssincerely.com': true,
  'yourteacher.net': true,
  'yourwap.com': true,
  'youthfire.com': true,
  'youthpost.com': true,
  'youvegotmail.net': true,
  'yuuhuu.net': true,
  'yuurok.com': true,
  'yyhmail.com': true,
  'z1p.biz': true,
  'z6.com': true,
  'z9mail.com': true,
  'za.com': true,
  'zahadum.com': true,
  'zaktouni.fr': true,
  'zcities.com': true,
  'zdnetmail.com': true,
  'zdorovja.net': true,
  'zeeks.com': true,
  'zeepost.nl': true,
  'zehnminuten.de': true,
  'zehnminutenmail.de': true,
  'zensearch.com': true,
  'zensearch.net': true,
  'zerocrime.org': true,
  'zetmail.com': true,
  'zhaowei.net': true,
  'zhouemail.510520.org': true,
  'ziggo.nl': true,
  'zing.vn': true,
  'zionweb.org': true,
  'zip.net': true,
  'zipido.com': true,
  'ziplip.com': true,
  'zipmail.com': true,
  'zipmail.com.br': true,
  'zipmax.com': true,
  'zippymail.info': true,
  'zmail.pt': true,
  'zmail.ru': true,
  'zoemail.com': true,
  'zoemail.net': true,
  'zoemail.org': true,
  'zoho.com': true,
  'zomg.info': true,
  'zonai.com': true,
  'zoneview.net': true,
  'zonnet.nl': true,
  'zooglemail.com': true,
  'zoominternet.net': true,
  'zubee.com': true,
  'zuvio.com': true,
  'zuzzurello.com': true,
  'zvmail.com': true,
  'zwallet.com': true,
  'zweb.in': true,
  'zxcv.com': true,
  'zxcvbnm.com': true,
  'zybermail.com': true,
  'zydecofan.com': true,
  'zzn.com': true,
  'zzom.co.uk': true,
  'zzz.com': true,
};
